import { Code } from 'constants/codes';
import { Fixture } from 'fixtures/values';
import DOMPurify from 'dompurify';
import { ItemCalculate, OptionType, CommonDataColumn } from 'models/BaseModel';
import { Files } from './FileHelpers';
import { MediaList } from 'models/BaseModel';
import { Extract } from 'helpers/ExtractHelper'
import { Privilege} from 'models/BaseModel'
import { Security} from 'helpers/SecurityHelper'
import { ChangeEvent, Dispatch, SetStateAction, useRef } from 'react';
import { MessageType, GroupMapData } from 'models/BaseModel';
import { ItemInventory } from 'models/ItemInventoryModel';
import { ExamField as EMF } from 'constants/codes';
import { SaleItem } from 'models/SaleItemModel';
import { Inventory } from 'models/InventoryModel';


//set values to local storage of the browser.
const setStorage = (key: string, value: string | number| undefined): void => {
    if(value){
        localStorage.setItem(key, value.toString());
    }  
  };
  
//get values from local storage of the browser.
const getStorage = (key: string): string | null => {
    const value = localStorage.getItem(key);
    if(value)
    {
      return value;
    }
    return null
};

const setStorageSecure = (key: string, value: string): void => {
  localStorage.setItem(key, Security.Cipher.encrypt(value));
};

//get values from local storage of the browser.
const getStorageSecure = (key: string): string => {
  const value = localStorage.getItem(key);
  if(value)
  {
    return Security.Cipher.decrypt(value);
  }
  return "";
};

//delete values from local storage of the browser.
const deleteStorage = (key: string): void => {
    localStorage.removeItem(key);
  };

const stringToList = (items: string): string[] => {
    if(items)
    {
      if(items.includes(',')) {
        if (/[{}']/g.test(items)) {
          items = items.replace(/[{}']/g, '');
        }
        return items
          .split(',')
          .map(item => item.trim())
          .filter(item => item.length > 0);
      }
      else{
        return [items];
      }
    }
    return [];
  };

const toSetString = (data: string | undefined): Set<string> => {
  if(!data) return new Set<string>();;
  try {
      const parsedMenuList: string[] = JSON.parse(data) as string[];
      const newSet = new Set<string>(parsedMenuList);
      return newSet;
    } catch {
      return new Set<string>();
    }
  };
  
const correctTime = (time: string | undefined ): string  | undefined => {
  if(time)
  {
    if (time.includes(":") && time.length === 5) {
      return `${time}:00`; 
    }
  }
  return time;
};
const correctDateOrToday = (date: Date | undefined ): Date => {
  if(date)
  {
    return date;
  }
  return Utility.Date.Current();
};

const correctTimeOrNow = (time: string | undefined ): string  | undefined => {
  if(time)
  {
    time = correctTime(time);
    return time;
  }
  return Utility.Date.CurrentTime();
};

const Delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

const SaveStart = async (): Promise<void> => {
  const btnSave = document.getElementById('btnSave');
  if(btnSave) {
    btnSave.classList.add('spintext');
    await new Promise(resolve => setTimeout(resolve, 500)); 
  }
};
  
const SaveEnd = (): void =>  {
    const btnSave = document.getElementById('btnSave');
    if(btnSave) {
      btnSave?.classList.remove('spintext');
    }
  };

const AttachFileStart = async (): Promise<void> =>
  {
    const btnSave = document.getElementById('btnFileAttach');
    if(btnSave) {
      btnSave.classList.add('spintext');
      await new Promise(resolve => setTimeout(resolve, 500)); 
    }
  };
  
const AttachFileEnd = (): void =>
  {
    const btnSave = document.getElementById('btnFileAttach');
    if(btnSave) {
      btnSave?.classList.remove('spintext');
    }
  };

const DeleteFileStart = async (): Promise<void> =>
  {
    const btnSave = document.getElementById('btnFileDelete');
    if(btnSave) {
      btnSave.classList.add('spintext');
      await new Promise(resolve => setTimeout(resolve, 500)); 
    }
  };
  
const DeleteFileEnd = (): void =>
  {
    const btnSave = document.getElementById('btnFileDelete');
    if(btnSave) {
      btnSave?.classList.remove('spintext');
    }
  };
  
const DeleteStart = async (): Promise<void> =>
  {
    const btnApply = document.getElementById('btnDelete');
    if(btnApply) {
      btnApply.style.backgroundImage = 'none';
      btnApply.classList.add('spinner');
      await new Promise(resolve => setTimeout(resolve, 500)); 
    }
  };
  
const DeleteEnd = (): void =>
  {
    const btnApply = document.getElementById('btnDelete');
    if(btnApply) {
      let backImage = btnApply.style.backgroundImage;
      btnApply.style.backgroundImage = backImage;
      btnApply.classList.remove('spinner');
    }
  };
  
const handleError = (error: any): Promise<never> => {
    console.error('Fetch error:', error);
    return Promise.reject('An unexpected error occurred.');
  };

 const handleCalculation = <T>(
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
    setFormData: React.Dispatch<React.SetStateAction<T>>,
    calculateFunction: (data: T) => T
  ) => {
    setFormData((prev) => {
      const { id, value } = e.target;
      const updatedFormData = { ...prev, [id]: value ? Number(value) : 0 };
      return calculateFunction(updatedFormData);
    });
  };
  
const setCookie = (name: string, value: string, days: number): void => {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/`;
  };
    
const getCookie = (name: string): string | null => {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
      const [key, value] = cookie.split('=');
      if (key === name) return value;
    }
    return null;
  };
  
const deleteCookie = (name: string): void => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
  };
  
const isValidDate = (dateString: string): boolean => {
  // Try parsing the string into a Date object
  const date = new Date(dateString);

  // Check if the parsed date is valid
  return !isNaN(date.getTime());
};

const isValidEmail = (email: string | undefined): boolean => {
  if (email === null || email === undefined) {
    return false;
  }
  
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

const isValidPhoneFormat = (phone: string): boolean => {
  const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
  return phoneRegex.test(phone);
};

const isValidPhone = (phoneNumber: string | undefined): boolean => {
  return phoneNumber !== null && phoneNumber !== undefined && phoneNumber.length === 10;
};


function isValidAccessToken(token: string | null | undefined): boolean {
  if (!token || token.split(".").length !== 3) {
    console.error("Invalid token format");
    return false;
  }

  try {
    // Extract the payload part
    const payloadBase64 = token.split(".")[1];

    // Convert Base64URL to Base64 (replace non-standard characters and add padding)
    const base64 = payloadBase64.replace(/-/g, "+").replace(/_/g, "/");
    const paddedBase64 = base64.padEnd(base64.length + (4 - (base64.length % 4)) % 4, "=");

    // Decode and parse the payload
    const payloadJson = atob(paddedBase64);
    const payload = JSON.parse(payloadJson);

    // Get the current timestamp in seconds
    const currentTime = Math.floor(Date.now() / 1000);

    return payload.exp > currentTime;
  } catch (error) {
    console.error("Invalid token:", error);
    return false;
  }
}

// function isValidAccessToken(token: string): boolean {
//   try {
//       // Decode the token without verifying it (base64 decoding).
//       const payloadBase64 = token.split('.')[1];
//       const payloadJson = atob(payloadBase64);
//       const payload = JSON.parse(payloadJson);

//       // Get the current timestamp in seconds.
//       const currentTime = Math.floor(Date.now() / 1000);

//       // Check if the token is valid.
//       return payload.exp > currentTime;
//   } 
//   catch (error) {
//       console.error('Invalid token:', error);
//       // If token is invalid, consider it expired.
//       return false;
//   }
// }

function isValidRefreshToken(token: string): boolean {
  try {
      // Decode the token without verifying it (base64 decoding).
      const payloadBase64 = token.split('.')[1];
      const payloadJson = atob(payloadBase64);
      const payload = JSON.parse(payloadJson);

      // Get the current timestamp in seconds.
      const currentTime = Math.floor(Date.now() / 1000);

      // Check if the token has expired.
      return payload.exp > currentTime;
  } 
  catch (error) {
      console.error('Invalid token:', error);
      // If token is invalid, consider it expired.
      return false;
  }
}

const IsValidOrExistsLocal = async (fileName: string | undefined) => {
  if (!fileName) return false;
  
  try {
    const response = await Files.Local.Exists(fileName); 
    return response; 
  } catch (error) {
    console.error("Error validating file:", error);
    return false;
  }
};

const IsValidOrExistsFile = async (fileName: string | undefined) => {
  if (!fileName) return false;
  
  try {
    const response = await Files.File.Exists(fileName, "document"); 
    return response; 
  } catch (error) {
    console.error("Error validating file:", error);
    return false;
  }
};

const toUTCDate = (date?: Date | string | undefined): Date => {
    if (!date) {
      return new Date(Date.UTC(1900, 0, 1, 0, 0, 0, 0)); 
    }

    const d = typeof date === "string" ? new Date(date) : date;

    return new Date(Date.UTC(
      d.getFullYear(),
      d.getMonth(),
      d.getDate(),
      d.getHours(),
      d.getMinutes(),
      d.getSeconds(),
      d.getMilliseconds()
    ));
  }

  const toLocalDate = (date: Date): Date => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const milliseconds = date.getMilliseconds();
    
    // Create new Date in UTC with local values
    return new Date(Date.UTC(year, month, day, hours, minutes, seconds, milliseconds));
  };

const formatDate = (date: Date | string | undefined, format: string = Code.Format.DateTime.Date): string => {

  if (!date) return '';

  const parsedDate = typeof date === 'string' ? new Date(date) : date;

  if(parsedDate && isValidDate(parsedDate.toString())) {

    let year, month, monthName, monthShort, day, dayName, dayShort, hours, minutes, seconds, ampm; 

    if(format.includes('yyyy')) {
      year = parsedDate.getFullYear();
      format = format.replace('yyyy', String(year));
    }

    if(format.includes('yy')) {
      year = parsedDate.getFullYear();
      format = format.replace('yy', String(year).slice(-2));
    }

    if(format.includes('MMMMM')){
      monthName = parsedDate.toLocaleString('default', { month: 'long' });
      format = format.replace('MMMMM', monthName);
    }

    if(format.includes('MMM')) {
      monthShort = parsedDate.toLocaleString('default', { month: 'short' }) 
      format = format.replace('MMM', monthShort);
    }

    if(format.includes('MM')) {
      month = String(parsedDate.getMonth() + 1).padStart(2, '0');
      format = format.replace('MM', month);
    }

    if(format.includes('ddddd')) {
      dayName = parsedDate.toLocaleString('default', { weekday: 'long' });
      format = format.replace('ddddd', dayName);
    }

    if(format.includes('ddd')) {
      dayShort = parsedDate.toLocaleString('default', { weekday: 'short' });
      format = format.replace('ddd', dayShort);
    }

    if(format.includes('dd')) {
      day = String(parsedDate.getDate()).padStart(2, '0');
      format = format.replace('dd', day);
    }

    if(format.includes('HH')) {
      hours = String(parsedDate.getHours()).padStart(2, '0'); // 24-hour format
      format = format.replace('HH', hours);
    }

    if(format.includes('hh')) {
      hours = String(parsedDate.getHours() % 12 || 12).padStart(2, '0');
      format = format.replace('hh', hours);
    }

    if(format.includes('mm')) {
      minutes = String(parsedDate.getMinutes()).padStart(2, '0');
      format = format.replace('mm', minutes);
    }

    if(format.includes('ss')) {
      seconds = String(parsedDate.getSeconds()).padStart(2, '0');
      format = format.replace('ss', seconds);
    }

    if(format.includes('tt')) {
      ampm = (parsedDate.getHours() >= 12 ? 'PM' : 'AM');
      format = format.replace('tt', ampm);
    }

    return format.replace("1900-01-01","");
  }
  return '';

};

// function getDateNow(): Date {
//   const d = new Date();
//   d.setHours(d.getHours() - 7); // Assuming 7 hours difference for Alberta timezone
//   return d;
// }

function getDateNow(): Date {
  return new Date(
    new Date().toLocaleString("en-US", { timeZone: "America/Edmonton" })
  );
}

const formatViewDate = (value?: Date | undefined, isProtected: boolean = false): string => {
  if (value === undefined || value == null) return "";

  // If value is valid, format the date in 'yyyy-mm-dd'
  const date = new Date(value);
  if(isProtected){
    return formatDate(date,'yyyy-XX-XX').replaceAll("1900-XX-XX","")  // '1980-12-04'
  }
  else{
    return formatDate(date,'yyyy-MM-dd').replaceAll("1900-01-01","")  // '1980-12-04'
  }
  
}; 

const formatViewDateTime = (value?: Date | undefined): string => {
  if (value === undefined || value == null) return "";

  // If value is valid, format the date in 'yyyy-mm-dd'
  const date = new Date(value);
  return formatDate(date,'yyyy-MM-dd hh:mm tt').replaceAll("1900-01-01 12:00 AM","")  // 'Dec 04, 1980'
};  

const formatSafeDate = (input: string): string => {
  const [datePart, timePart] = input.split(" ");
  const [year, month, day] = datePart.split("/").map(Number);
  const [hours, minutes, seconds] = timePart.split(":").map(Number);

  // Construct a Date object without triggering timezone conversion
  const safeDate = new Date(year, month - 1, day, hours, minutes, seconds);

  // Format to "yyyy-MM-dd"
  return safeDate.toISOString().slice(0, 10);
}

const formatViewTime = (value?: Date | undefined): string => {
  if (value === undefined || value == null) return "";

  // If value is valid, format the date in 'yyyy-mm-dd'
  const date = new Date(value);
  return formatDate(date,'hh:mm tt').replaceAll("Jan 01, 1900 12:00 AM","")  // 'Dec 04, 1980'
}; 

const formatStringTime = (time?: string | undefined): string => {
  if (time === undefined || time == null) return "";

  ////console.log("formatStringTime:", time)

  // If value is valid, format the date in 'yyyy-mm-dd'
  const date = new Date(`1900-01-01T${time}`);

  ////console.log("formatStringTime:", date)

  return formatDate(date,'hh:mm tt').replaceAll("12:00 AM","")  // 'Dec 04, 1980'
}; 

const formatAmount = (amount: number | string | undefined): string => {
    // Convert the input to a number if it's a string
    if (amount === undefined || amount === null) return '';

    const numericAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  
    // Check if the converted amount is a valid number
    if (isNaN(numericAmount)) {
      throw new Error('Invalid amount provided to formatAmount.');
    }
  
    // Format the amount with a dollar sign and two decimal places
    return `$${numericAmount.toFixed(2)}`;
  };

const toTitleCase = (value?: string) => {
  return value?.replace(/\w\S*/g, (txt) => {
    // Ignore words that are already in ALL CAPS (2+ uppercase letters)
    if (txt === txt.toUpperCase() && txt.length > 1) {
      return txt;
    }
    return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
  }) || '';
};

const getDocumentType = (name: string): number | undefined => {
  const upperName = name.toUpperCase() as keyof typeof Code.Option.DocumentType;
  const value = Code.Option.DocumentType[upperName];
  return typeof value === "number" ? value : 2;
};

const toNumber = (phone?: string): string => {
      // Removes all non-numeric characters
    return phone?.replace(/\D/g, '') || '';
};



const toPhoneFormat = (phone?: string, isProtected: boolean = false): string => {
  if (phone) {
    const cleaned = phone.replace(/\D/g, ''); // Remove non-numeric characters
    if (cleaned.length !== 10) return phone;  // Return as is if not exactly 10 digits
    
    if (isProtected) {
      return `XXX-XXX-${cleaned.slice(6, 10)}`;
    } else {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    }
  } else {
    return '';
  }
};

const ToPhoneFormatTyping = (value: string): string => {
    // Remove all non-digit characters
    const cleaned = value.replace(/\D/g, '');
  
    // Format as (XXX) XXX - XXXX
    if (cleaned.length <= 3) {
      return `${cleaned}`;
    } else if (cleaned.length <= 7) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
    } else {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    }
  };

const getProductInfo = (productName?: string, skuCode?: string, utnCode?: string, itemDesc?: string): string => {
    let value = '';
    if(productName) value += `<span class='bold'>${productName}</span>`;
    if(skuCode) {
      value += `<span>SKU: ${skuCode}</span>`;
    } else if(utnCode) {
      value += `<span>UTN: ${utnCode}</span>`;
    }
    if(itemDesc) value += `<span>${itemDesc}</span>`;
    return value
  };  

const getProductQuick = (productName?: string, skuCode?: string, utnCode?: string): string => {
    let value = '';
    if(productName) value += `${productName}`;
    if(skuCode) {
      value += ` SKU: ${skuCode}`;
    } else if(utnCode) {
      value += ` UTN: ${utnCode}`;
    }
    return value
  };  


  

const sanitizeAll = (data: Record<string, any>) => {
  return Object.fromEntries(
    Object.entries(data).map(([key, value]) => [key, sanitizeValue(value)])
  );
  };

const sanitizeValue = (value: any) => {
    if (typeof value === 'string') {
      value = DOMPurify.sanitize(value.trim());
      value = sanitizeScripts(value);
      return value;
    }
    return value;
  };

const sanitizeScripts = (input: string): string => {
    // Remove <script> and other JavaScript-related tags
    const scriptTagRegex = /<script[^>]*>([\s\S]*?)<\/script>/gi;

    // Matches inline EVENT handlers like onClick, onload etc.
    const onEventAttributesRegex = /on\w+='[^']*'/gi;  
  
    // Remove <script> tags
    let sanitizedInput = input.replace(scriptTagRegex, '');
  
    // Remove inline event handlers (e.g., onClick, onload, etc.)
    sanitizedInput = sanitizedInput.replace(onEventAttributesRegex, '');
  
    // Additional cleaning or further sanitization can go here
    return sanitizedInput;
  };

const StandardKeyboardCharsOnly = (input: string): string => {
    if (!input) return '';

    // Matches: letters, digits, whitespace, and all standard US keyboard symbols
    // Symbols included: ` ~ ! @ # $ % ^ & * ( ) - _ = + [ ] { } \ | ; : ' " , . < > / ?
    const allowedPattern = /[^a-zA-Z0-9\s`~!@#$%^&*()\-_=+\[\]{}\\|;:'",.<>/?]/g;

    return input.replace(allowedPattern, '');
}

const onPopupFormClose = (): void => {
    //console.log("onPopupFormClose called");
    window.parent.postMessage(Code.Command.ON_POPUP_FORM_CLOSE, '*');
  };

const putStringValue = (value: any, defaultValue: any = '') => {
    return value !== undefined && value !== null ? value : defaultValue;
  };

const putOptionValue = (value: any, defaultValue: any = 0) => {
    return value !== undefined && value !== null ? value : defaultValue;
  };

const putNumbericValue = (value: any, defaultValue: any = 0) => {
    return value !== undefined && value !== null ? value : defaultValue;
  };

const putDateValue = (value: any) => {
    if (value !== undefined && value !== null) {
      // If value is valid, format the date in 'yyyy-mm-dd'
      const date = new Date(value);
      //return date.toISOString().split('T')[0]; 
      return date.toISOString(); // 'yyyy-mm-dd'
    }
    
    // Return today's date if value is null or undefined
    const today = new Date();
    //return today.toISOString().split('T')[0];
    return today.toISOString(); // 'yyyy-mm-dd'
  };

const putActiveValue = (Data: any[]): number => {
    return Data[0]?.id ?? 0;
  };

const putRowValue = (Data: any[]): number => {
    return Data[0]?.id ?? 20;
  };

//fetch data from database and map and join the fields and set as option data. 
const mapDataToOptions = (
    data: any[], 
    valueField: string, 
    labelFields: string | string[] ,
    first: number,
  ): OptionType[] => {
    const defaultOption = getDefaultOption(first);
    let joiner = ' - ';
    let prefix = '';

    if(valueField==='client_id'){
      joiner = ' ';
      prefix = '#';
    }

    const mappedOptions = data.map(item => {
      let name = Array.isArray(labelFields) 
        ? labelFields.map(field => item[field]).filter(Boolean).join(joiner) 
        : item[labelFields]; 

      return {
        value: item[valueField],
        label:  `${prefix}${name}`
      };
    });

    return defaultOption ? [defaultOption, ...mappedOptions] : mappedOptions;
  };


const getAsyncValue = (value?: number, label?: string) : { value: number; label: string } | null => {
    return value ? { value: value ?? 0, label: label ?? '' } : null;
  }

const joinUrl = (basePath: string, ...params: (string | number | undefined)[]): string => {
    var path =  [basePath, ...params.filter(param => param !== undefined)].join('/')
    return path;
  };

const joinEditUrl = (Privilege: Privilege, basePath: string, ...params: (string | number | undefined)[]): string => {
    if(Privilege.ALL || Privilege.VIEW || Privilege.MODIFY || Privilege.OPEN)
    {
      return [basePath, ...params.filter(param => param !== undefined)].join('/');
    }
    return Code.Path.NO_PRIVILEGE;
  };

const joinPrintUrl = (Privilege: Privilege, basePath: string, ...params: (string | number | undefined)[]): string => {
    if(Privilege.ALL || Privilege.PRINT)
    {
      params.splice(0, 0, "print");
      return [basePath, ...params.filter(param => param !== undefined)].join('/');
    }
    return Code.Path.NO_PRIVILEGE;
  };

  const joinPrint2Url = (Privilege: Privilege, basePath: string, ...params: (string | number | undefined)[]): string => {
    if(Privilege.ALL || Privilege.PRINT)
    {
      params.splice(0, 0, "print2");
      return [basePath, ...params.filter(param => param !== undefined)].join('/');
    }
    return Code.Path.NO_PRIVILEGE;
  };

const JoinString = (baseValue: string, ...params: (string | number | undefined)[]): string => {
  return [baseValue, ...params.filter(param => param !== undefined)].join(' ');
};

const JoinFields = (fields: string[]): string => {
  return fields.join(',');
};
    
const formWidth = (url: string): number => {

  console.log("url>>>>", url);

  const LARGE = [
    Code.Form.Name.INVOICE,
    Code.Form.Name.PURCHASE, 
    Code.Form.Name.PROFORMA,
    Code.Form.Name.RELEASE,
    Code.Form.Name.ORDERS,
    Code.Form.Name.DOCUMENT,
    Code.Form.Name.DISPENSE,
    Code.Form.Name.STOCK,
    Code.Form.Name.ESTIMATE,
    Code.Form.Name.DELIVERY,
    Code.Form.Name.CLAIM,
    Code.Form.Name.REMITTANCE,
    Code.Form.Name.PRESCRIPTION,
    Code.Form.Name.DAYBOOK,
    Code.Form.Name.TEMPLATE,
    Code.Form.Name.REFERRAL,
    Code.Form.Name.REPORT,
    "multibilling",
    "multischedule"
  ];

  const XLARGE = [
    Code.Form.Name.ROLE,
    Code.Form.Name.SALE
  ];
  
  const SMALL = [
    Code.Form.Name.COMMUNICATION,
    Code.Form.Name.MARKING
  ];

  const MAX = [
    Code.Form.Name.CLIENT,
    Code.Form.Name.EXAM,
    Code.Form.Name.EXAMTEMPLATE,
    Code.Form.Name.TIME
  ];

  if(
    url.includes("exam/print2")
    ) {
    return Code.Form.Size.MAX; 
  }
  else if(url.includes(Code.Form.Name.PRINT) || url.includes(Code.Form.Name.CALENDAR)) {
    return Code.Form.Size.LARGE; 
  }
  else if(
    url.includes("inventory/item") ||
    url.includes(Code.Form.Name.EXAMTEMPLATE) ||
    url.includes("familycredit")
    ) {
    return Code.Form.Size.MAX; 
  }
  else if(
    url.includes(Code.Form.Name.ITEM) || 
    url.includes(Code.Form.Name.SALEORDER) || 
    url.includes(Code.Form.Name.EXAMTYPE ) || 
    url.includes(Code.Form.Name.SALEITEM) ||
    url.includes(Code.Form.Name.APPOINTMENT)
  ) 
  {
    return Code.Form.Size.XXSMALL; 
  }
  else if (LARGE.some((forms) => url.includes(forms))) {
    return Code.Form.Size.LARGE;
  }
  else if (XLARGE.some((forms) => url.includes(forms))) {
    return Code.Form.Size.XLARGE;
  }
  else if (SMALL.some((forms) => url.includes(forms))) {
    return Code.Form.Size.SMALL;
  }
  else if (MAX.some((forms) => url.includes(forms))) {
    return Code.Form.Size.MAX;
  }
  else 
    return Code.Form.Size.XXSMALL; 
  
};

const formColumnStyle = (input: [number, number, number, string?] | null | undefined): string => {
  if (!input) return 'form-col100'; // Handle null or undefined case

  const [pl, col, pr, extra] = input; // Destructure input for readability
  let baseClass = `fleft form-col${col} pl${pl} pr${pr}`;

  return extra ? `${baseClass} ${extra}` : baseClass;
};

const formListStyle = (input: [number, string?] | null | undefined): string => {
  if (!input) return 'form-col100'; // Handle null or undefined case

  const [col, extra] = input; // Destructure input for readability
  let baseClass = `form-col${col}`;

  return extra ? `${baseClass} ${extra}` : baseClass;
};


const amountToTwoDecimal = (value: number) => {
  return Number(value);
}
//const amountToTwoDecimal = (value: number) => Number(value.toFixed(2));
// const amountToTwoDecimal = (value: string | number): string | number => {
//   const str = String(value);

//   // Preserve incomplete typing states so the user can keep typing
//   if (str === "-" || str === "." || str === "-." || str.endsWith(".")) {
//     return str;
//   }

//   const num = Number(str);

//   // Return the raw string if it's not a valid number
//   if (isNaN(num)) return str;

//   return Number(num.toFixed(2));
// };

const twoDecimal = (value: string | number): number => parseFloat(Number(value).toFixed(2));

const getOptionValues = (keys: number[]) => {
  return  Fixture.OptionValues.filter(option => keys.includes(option.value));
};

const pageColumnStyle = (input: [number, number, number, number?, string?] | null | undefined): string => {
  if (!input) return 'fl page-col8'; // Handle null or undefined case

  const [pl, col, pr, order, extra] = input; // Destructure input for readability
  let baseClass = `fl page-col${col} pl${pl} pr${pr} order${order}`;

  return extra ? `${baseClass} ${extra}` : baseClass;
};

const fullColumnStyle = (input: [number, number, number, number, number, number?, string?] | null | undefined): string => {
  if (!input) return 'fl page-col8'; // Handle null or undefined case

  const [col, pt, pr, pb, pl, order, extra] = input; // Destructure input for readability
  let baseClass = `fl page-col${col} pt${pt} pr${pr} pb${pb} pb${pl} order${order}`;

  return extra ? `${baseClass} ${extra}` : baseClass;
};

const getCurrentTab = (formName: string) => {
  return localStorage.getItem(`${formName}Tab`) || "tab1";
};

const setCurrentTab = (formName: string, id: string) => {
  localStorage.setItem(`${formName}Tab`, id); // Save to localStorage
};

function ArrayToCSV(value: string | any) {
  try {
    // If the value is a string, attempt to parse it
    const parsedArray = typeof value === "string" ? JSON.parse(value) : value;

    // Check if parsedArray is actually an array
    if (Array.isArray(parsedArray)) {
      return `"${parsedArray.join('","')}"`;
    } else {
      return '';
    }
  } catch (error) {
    console.error("ArrayToCSV:", error);
    return '';
  }
}

const getUserImage = (Image: string | null ): string => {
  if(Image) {
    return Image;
  }
  return "assets/images/user/boy.png";
};

const getBlobImage = async (keyName: keyof MediaList, fileList: string | null): Promise<string | null> => {
  if (fileList) {
    const fileListData = Files.List.return(fileList);
    if (fileListData) {
      const blobImage = await Files.ImageAPI.return(keyName, fileListData);
      if (blobImage) {
        return blobImage; 
      }
    }
  }
  return null;
};

const getCompanyName = (): string => {
  return Utility.Storage.GetSecure(Code.LocalKey.CompanyName);
};

const getLocationName = (): string => {
  return Utility.Storage.GetSecure(Code.LocalKey.LocationName);
};

const getLocationColor = (): string => {
  return Utility.Storage.GetSecure(Code.LocalKey.LocationColor);
};

const getUserName = (): string => {
  return Utility.Storage.GetSecure(Code.LocalKey.UserName);
};

const getCompanyId = (): number => {
  return Extract.Key.Decode(Utility.Storage.Get(Code.LocalKey.CompanyKey));
};

const getLocationId = (): number => {
  return Extract.Key.Decode(Utility.Storage.Get(Code.LocalKey.LocationKey));
};

const getDatabaseId = (): number => {
  return Extract.Key.Decode(Utility.Storage.Get(Code.LocalKey.DataKey));
};

const getUserId = (): number => {
  return Extract.Key.Decode(Utility.Storage.Get(Code.LocalKey.UserKey));
};

const getDoctorId = (): number => {
  return Extract.Key.Decode(Utility.Storage.Get(Code.LocalKey.DoctorKey));
};

const getEmployeeId = (): number => {
  return Extract.Key.Decode(Utility.Storage.Get(Code.LocalKey.EmployeeKey));
};

const getPrivilegeList = (): string => {
  return Utility.Storage.GetSecure(Code.LocalKey.PrivilegeList);
};

const getSpecialList = (): string => {
  return Utility.Storage.GetSecure(Code.LocalKey.SpecialList);
};

const getReportList = (): string => {
  return Utility.Storage.GetSecure(Code.LocalKey.ReportList);
};

const getDoctorList = (): string => {
  return Utility.Storage.GetSecure(Code.LocalKey.DoctorList);
};

const getLocationList = (): string => {
  return Utility.Storage.GetSecure(Code.LocalKey.LocationList);
};

const getFileList = (): string => {
  return Utility.Storage.GetSecure(Code.LocalKey.FileList);
};




const getFullName = <T extends Record<string, any>>(data?: T | null, key?: string): string => {
  if (!data) return ""; 

  return `${data[`${key}_first_name`]} ${data[`${key}_middle_name`]} ${data[`${key}_last_name`]}`;
};

const getClientName = (data?: any, format: number = 0): string => {
  if (!data) return ""; 

  let name = `#${data.client_number || ''}, ${data.client_first_name || ''} ${data.client_middle_name || ''} ${data.client_last_name || ''} `;

  if(format == Code.Format.Client.ADDRESS_PHONE ){
    name += data.client_address ? `, ${data.client_address}` : '';
    name += data.client_phone ? `, ${data.client_phone}` : '';
  }
  else if(format == Code.Format.Client.AGE_ADDRESS ){
    let age = Utility.Format.Age(data.client_dob);
    name += age ? `, ${age}` : '';
    //name += `${Utility.Format.Age(data.client_dob,', ','')} `
    name += data.client_address ? `, ${data.client_address}` : '';
  }
  return name.trim();
};

const getClientNameHtml = (data?: any, format: number = 0): string => {
  if (!data) return ""; 

  let name = data.client_number ? `<span class='copy'>#${data.client_number || ''}</span>,` : '';
  name += `<span class='copy'>`;
  name += data.client_first_name ? ` ${data.client_first_name}` : '';
  name += data.client_middle_name ? ` ${data.client_middle_name}` : '';
  name += data.client_last_name ? ` ${data.client_last_name}` : '';
  name += `</span>`;

  if(format == Code.Format.Client.ADDRESS_PHONE ){
    name += data.client_address ? `, <span class='copy'>${data.client_address}</span>` : '';
    name += data.client_phone ? `, <span class='copy'>${data.client_phone}</span>` : '';
  }
  else if(format == Code.Format.Client.AGE ){
    let age = Utility.Format.Age(data.client_dob);
    name += age ? `, ${age}` : '';
  }
  else if(format == Code.Format.Client.AGE_GENDER ){
    let gender = data.gender_id;
    name += gender ? gender == 10 ? ' (M)': gender == 11 ? ' (F)' : '' : '';
    let age = Utility.Format.Age(data.client_dob);
    name += age ? ` ${age}` : '';
  }
  else if(format == Code.Format.Client.AGE_ADDRESS ){
    let age = Utility.Format.Age(data.client_dob);
    name += age ? `, ${age}` : '';
    //name += `${Utility.Format.Age(data.client_dob,', ','')} `
    name += data.client_address ? `, <span class='copy'>${data.client_address}</span>` : '';
  }
  return name.trim();
};

const getAlignClass = (align: typeof Code.Align[keyof typeof Code.Align] | undefined): string | null => {
 return align === Code.Align.RIGHT ? "tright" 
      : align === Code.Align.CENTER ? "tcenter" 
      : '';
};

const getIcon = (title: string | undefined): string => {
  if(title) {
    title = title.toLowerCase();
    switch (true) {
      case title.includes("phone"): return "icon-space icon-phone";
      case title.includes("cell"): return "icon-space icon-phone";
      case title.includes("mobile"): return "icon-space icon-phone";
      case title.includes("email"): return "icon-space icon-email";
      case title.includes("website"): return "icon-space icon-web";
      case title.includes("fax"): return "icon-space icon-fax";
      default: return "";
    }
  }
  return "";
};

const formatSerialNumber = (format: string, serialNumber: number, locationId: number): string => {
  // Convert the serial number to string for easier manipulation
  const serialNumberStr = serialNumber.toString();
  const serialLength = serialNumberStr.length;

  // Split the format to get the parts before and after the {X}
  const [formatPart1, formatPart2] = format.split('{X}');
  
  // Ensure the prefix has leading zeros (if needed) based on the total length of the format
  const prefixLength = formatPart1.length - serialLength;
  const prefix = formatPart1.slice(0,prefixLength); // Add zeros to the left
  
  // Initialize the suffix
  let suffix = '';

  // Extract the suffix pattern from the format string (example: (10:C;11:P;12:N;))
  const suffixPattern = formatPart2.match(/\((\d{2}:[A-Za-z];\d{2}:[A-Za-z];\d{2}:[A-Za-z];)\)/);
  if (suffixPattern) {
    // Remove the surrounding parentheses and split by semicolons
    const suffixMapping = suffixPattern[1]
      .split(';')  // Split by semicolon
      .map(pair => pair.split(':'))  // Split each pair by colon
      .reduce((acc: { [key: number]: string }, [code, letter]) => {
        acc[parseInt(code)] = letter;
        return acc;
      }, {});

    // Look up the appropriate letter based on the company code
    suffix = suffixMapping[locationId] || '';  // Default to empty if no match is found
  }

  // Return the formatted serial number
  return `${prefix}${serialNumberStr}${suffix}`;
};

const setPageTitle = (pageTitle: string, addon?: number, isPostfix: boolean = true) => {
  let title = pageTitle;

  if(isPostfix){
    if (addon === 1) {
      title = `${title} | ${Code.Info.SoftwareName} ${Code.Info.SoftwareVersion}`;
    }
  }
  else{
    if (addon === 1) {
      title = `${Code.Info.SoftwareName} ${Code.Info.SoftwareVersion} | ${title}`;
    }
  }
  
  document.title = title;
};

const cleanObject = <T extends Record<string, any>>(obj: T): T => {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value !== null && value !== undefined)
  ) as T;
};

const cleanJsonObject = <T extends Record<string, any>>(obj: T): string => {
  var cleanObj = cleanObject(obj);
    var stringify = JSON.stringify(cleanObj);
    ////console.log("before clear:", stringify);
    var cleanJson = Utility.Clean.Json(stringify);
    ////console.log("after clear:", cleanJson);
    return cleanJson; 
};

const cleanJson = (data: string): string => {
  return data
    .replaceAll(/,\s*}/g, '}')
    .replaceAll(/,\s*]/g, ']')
    .replaceAll('\\r', '\\\\r')
    .replaceAll('\\n', '\\\\n')
    .replaceAll(/\r/g, '\\r')
    .replaceAll(/\n/g, '\\n');
};

// const getFieldValue = <T extends Record<string, any>>(formData: T, key: keyof T) => {
//   return formData[key] || "";
// };

const getFieldValue = <T extends Record<string, any>>(formData: T, key: keyof T): any => {
  return formData[key] || "";
};

const calculateAge = (dob?: string | Date, prefix?: string, postfix?: string): string => {
  if (!dob) return "";

  const dobDate = typeof dob === "string" ? new Date(dob) : dob;

  if (isNaN(dobDate.getTime())) return "";

  if (dobDate.getFullYear() === 1900) return "";

  const today = new Date();

  let years = today.getFullYear() - dobDate.getFullYear();
  let months = today.getMonth() - dobDate.getMonth();
  const days = today.getDate() - dobDate.getDate();

  if (months < 0 || (months === 0 && days < 0)) {
    years--;
    months += 12;
  }

  if (days < 0) {
    months--;
    if (months < 0) {
      years--;
      months += 12;
    }
  }

  const yearPart = `${years}y`;
  const monthPart = `${months}m`;

  return `${prefix ?? ""}${yearPart}${monthPart}${postfix ?? ""}`.trim();
};

const calculateAgeYear = (dob?: string | Date): string => {
  if (!dob) return "";

  const dobDate = typeof dob === "string" ? new Date(dob) : dob;

  if (isNaN(dobDate.getTime())) return "";

  if (dobDate.getFullYear() === 1900) return "";

  const today = new Date();

  let years = today.getFullYear() - dobDate.getFullYear();
  let months = today.getMonth() - dobDate.getMonth();
  const days = today.getDate() - dobDate.getDate();

  if (months < 0 || (months === 0 && days < 0)) {
    years--;
    months += 12;
  }

  if (days < 0) {
    months--;
    if (months < 0) {
      years--;
      months += 12;
    }
  }

  const yearPart = `(${years}Y)`;
 
  return `${yearPart}`.trim();
};

const calculateAgeYear2 = (dob?: string | Date): number => {
  if (!dob) return 0;

  const dobDate = typeof dob === "string" ? new Date(dob) : dob;

  if (isNaN(dobDate.getTime())) return 0;

  if (dobDate.getFullYear() === 1900) return 0;

  const today = new Date();

  let years = today.getFullYear() - dobDate.getFullYear();
  let months = today.getMonth() - dobDate.getMonth();
  const days = today.getDate() - dobDate.getDate();

  if (months < 0 || (months === 0 && days < 0)) {
    years--;
    months += 12;
  }

  if (days < 0) {
    months--;
    if (months < 0) {
      years--;
      months += 12;
    }
  }

  const yearPart = `(${years}Y)`;
 
  return years;
};

const getGender = (gender_id?: number): string => {
  switch (gender_id) {
    case 10: return '(M)';
    case 11: return '(F)';
    default: return '';
  }
};

const getNewOld = (newold_id?: number): string => {
  switch (newold_id) {
    case 2: return '(NEW)';
    default: return '';
  }
};

const roundOffBy10 = (amount: number): number => {
  return Math.round(amount / 10) * 10;
};

const roundOffBy5 = (amount: number): number => {
  return Math.round(amount / 5) * 5;
};

const isAge19OrLess = (dobInput: string | Date): boolean => {
  const dob = new Date(dobInput);
  if (isNaN(dob.getTime())) {
    return false;
  }

  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();

  const hasNotHadBirthdayThisYear =
    today.getMonth() < dob.getMonth() ||
    (today.getMonth() === dob.getMonth() && today.getDate() < dob.getDate());

  if (hasNotHadBirthdayThisYear) {
    age--;
  }

  return age <= 19;
};

const reverseString = (input: string): string => {
  return input.split('').reverse().join('');
};

const unreverseString = (reversed: string): string => {
  return reversed.split('').reverse().join('');
}

const stringToBinary =(input: string): string => {
  return input
    .split('')
    .map(char => char.charCodeAt(0).toString(2).padStart(8, '0'))
    .join(' ');
}

const binaryToString =(binary: string): string => {
  return binary
    .split(' ')
    .map(bin => String.fromCharCode(parseInt(bin, 2)))
    .join('');
}

function handleClientChange(
  selected: OptionType | null,
  setFormData: React.Dispatch<React.SetStateAction<any>>
): void {
  if (!selected) return;
  setFormData((prev: any) => ({
    ...prev,
    client_id: selected.value,
    client_name: selected.label,
  }));
}

function handleProductChange(
  selected: OptionType | null,
  setFormData: React.Dispatch<React.SetStateAction<any>>
): void {
  if (!selected) return;
  setFormData((prev: any) => ({
    ...prev,
    product_id: selected.value,
    product_name: selected.label,
  }));
}

 const CheckKeyPressed = (eventInfo: any): { isCtrl: boolean; isAlt: boolean } => {
    const { jsEvent } = eventInfo;
    const isCtrl = jsEvent.ctrlKey || jsEvent.metaKey;
    const isAlt = jsEvent.altKey;
    return { isCtrl, isAlt };
  };

const getCorrectEndDate = (date: Date): Date => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() - 1);
  return newDate;
};

const convertHashString = (input: string): string => {
  if(input && input.includes('#')) {
    return input.split('#').filter(Boolean).join(',');
  }
  return input;
}

const getTotalHours = (startTime: string, endTime: string): string => {
    const start = new Date(`1970-01-01T${startTime}`);
    const end = new Date(`1970-01-01T${endTime}`);

    const diffMs = end.getTime() - start.getTime();
    const totalMinutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    const paddedMinutes = minutes.toString().padStart(2, "0");
    return `${hours}:${paddedMinutes}`;
  }

const setReload = (val: boolean) => { 
  Utility.Storage.Set("reload", val ? "1" : "0");
};

const getReload = (): boolean => {
  const reload = Utility.Storage.Get("reload");
  return reload === "1";
};

const getOrientationClass = (Orientation: number | undefined): string => {
  return Orientation == Code.Option.Oriantation.LANDSCAPE ? 'landscape':'';
};

const ValidateId = (
  Field1: number | undefined
): boolean => {
  return Field1 !== undefined && Field1 > 9;
};

const ValidateId2 = (
  Field1: number | undefined, 
  Field2: number | undefined
): boolean => {
  return  Field1 !== undefined && Field1 > 9 && 
          Field2 !== undefined && Field2 > 9;
};

const ValidateId3 = (
  Field1: number | undefined, 
  Field2: number | undefined, 
  Field3: number | undefined
): boolean => {
  return  Field1 !== undefined && Field1 > 9 && 
          Field2 !== undefined && Field2 > 9 && 
          Field3 !== undefined && Field3 > 9;
};

const ValidateId4 = (
  Field1: number | undefined, 
  Field2: number | undefined, 
  Field3: number | undefined,
  Field4: number | undefined
): boolean => {
  return  Field1 !== undefined && Field1 > 9 && 
          Field2 !== undefined && Field2 > 9 && 
          Field3 !== undefined && Field3 > 9 && 
          Field4 !== undefined && Field4 > 9;
};

const ValidateId5 = (
  Field1: number | undefined, 
  Field2: number | undefined, 
  Field3: number | undefined,
  Field4: number | undefined,
  Field5: number | undefined
): boolean => {
  return  Field1 !== undefined && Field1 > 9 && 
          Field2 !== undefined && Field2 > 9 && 
          Field3 !== undefined && Field3 > 9 && 
          Field4 !== undefined && Field4 > 9 && 
          Field5 !== undefined && Field5 > 9;
};

const getDateRangeBySession = (sessionId: number | null): { startDate: Date | undefined; endDate: Date | undefined } | null => {
  const today = new Date();

  const getStartOfWeek = (d = new Date()) => {
    const date = new Date(d);
    const day = date.getDay(); // 0 (Sun) to 6 (Sat)
    const diff = date.getDate() - day; // start from Sunday
    return new Date(date.setDate(diff));
  };

  const getEndOfWeek = (start: Date) => {
    const date = new Date(start);
    date.setDate(start.getDate() + 6);
    return date;
  };

  const getStartOfMonth = () => new Date(today.getFullYear(), today.getMonth(), 1);
  const getEndOfMonth = () => new Date(today.getFullYear(), today.getMonth() + 1, 0);

  const getStartOfQuarter = () => {
    const quarterStartMonth = Math.floor(today.getMonth() / 3) * 3;
    return new Date(today.getFullYear(), quarterStartMonth, 1);
  };
  const getEndOfQuarter = () => {
    const start = getStartOfQuarter();
    return new Date(start.getFullYear(), start.getMonth() + 3, 0);
  };

  const getStartOfYear = () => new Date(today.getFullYear(), 0, 1);
  const getEndOfYear = () => new Date(today.getFullYear(), 11, 31);

  switch (sessionId) {
    case 1: return { startDate: undefined, endDate: undefined }; 
    case 10: return { startDate: today, endDate: today }; // Today
    case 11: {
      const d = new Date(today);
      d.setDate(d.getDate() - 1);
      return { startDate: d, endDate: d };
    }
    case 12: {
      const d = new Date(today);
      d.setDate(d.getDate() + 1);
      return { startDate: d, endDate: d };
    }
    case 13: {
      const start = getStartOfWeek();
      return { startDate: start, endDate: getEndOfWeek(start) };
    }
    case 14: {
      const start = getStartOfWeek();
      start.setDate(start.getDate() - 7);
      return { startDate: start, endDate: getEndOfWeek(start) };
    }
    case 15: {
      const start = getStartOfWeek();
      start.setDate(start.getDate() + 7);
      return { startDate: start, endDate: getEndOfWeek(start) };
    }
    case 16: return { startDate: getStartOfMonth(), endDate: getEndOfMonth() };
    case 17: {
      const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const end = new Date(today.getFullYear(), today.getMonth(), 0);
      return { startDate: start, endDate: end };
    }
    case 18: {
      const start = new Date(today.getFullYear(), today.getMonth() + 1, 1);
      const end = new Date(today.getFullYear(), today.getMonth() + 2, 0);
      return { startDate: start, endDate: end };
    }
    case 19: return { startDate: getStartOfQuarter(), endDate: getEndOfQuarter() };
    case 20: {
      const start = getStartOfQuarter();
      start.setMonth(start.getMonth() - 3);
      const end = new Date(start.getFullYear(), start.getMonth() + 3, 0);
      return { startDate: start, endDate: end };
    }
    case 21: {
      const start = getStartOfQuarter();
      start.setMonth(start.getMonth() + 3);
      const end = new Date(start.getFullYear(), start.getMonth() + 3, 0);
      return { startDate: start, endDate: end };
    }
    case 22: return { startDate: getStartOfYear(), endDate: getEndOfYear() };
    case 23: {
      const start = new Date(today.getFullYear() - 1, 0, 1);
      const end = new Date(today.getFullYear() - 1, 11, 31);
      return { startDate: start, endDate: end };
    }
    case 24: {
      const start = new Date(today.getFullYear() + 1, 0, 1);
      const end = new Date(today.getFullYear() + 1, 11, 31);
      return { startDate: start, endDate: end };
    }
    case 25: {
      const start = new Date(today.getFullYear() - 1, 0, 1); // last year
      const end = new Date(today.getFullYear(), 11, 31);     // this year
      return { startDate: start, endDate: end };
    }
    case 26: {
      const start = new Date(today.getFullYear() - 2, 0, 1); // last 2 years
      const end = new Date(today.getFullYear(), 11, 31);     // this year
      return { startDate: start, endDate: end };
    }
    case 27: {
      const start = new Date(today.getFullYear() - 3, 0, 1); // last 3 years
      const end = new Date(today.getFullYear(), 11, 31);     // this year
      return { startDate: start, endDate: end };
    }
    case 28: {
      const start = new Date(today.getFullYear() - 4, 0, 1); // last 4 years
      const end = new Date(today.getFullYear(), 11, 31);     // this year
      return { startDate: start, endDate: end };
    }
    default: return null; // for custom or unknown sessions
  }
};

const getDefaultOption = (first: number): OptionType | undefined => {
  const optionMap: Record<number, OptionType> = {
    [Code.Option.Common.NA]: { value: Code.Option.Common.NA, label: "N/A" },
    [Code.Option.Common.SELECT]: { value: Code.Option.Common.SELECT, label: "Select" },
    [Code.Option.Common.ALL]: { value: Code.Option.Common.ALL, label: "All" },
    [Code.Option.Common.NONE]: { value: Code.Option.Common.NONE, label: "None" },
    [Code.Option.Common.GENERAL]: { value: Code.Option.Common.GENERAL, label: "General" },
    [Code.Option.Common.BLANK]: { value: Code.Option.Common.BLANK, label: "" },
  };

  return optionMap[first];
};

const mapAnyToOptions = <T>(
  valueKey: keyof T,
  labelKey: keyof T,
  dataList: T[],
  first: number,
): OptionType[] => {
  const defaultOption = getDefaultOption(first);
  const mappedOptions = dataList
    .map((item): OptionType | null => {
      const value = item[valueKey];
      const labelValue = item[labelKey];

      if (typeof value !== 'number') return null;

      const label =
        typeof labelKey === 'string' && labelKey.endsWith('_date') && typeof labelValue === 'string'
          ? Utility.Format.Date(new Date(labelValue))
          : String(labelValue);

      return { value, label };
    })
    .filter((opt): opt is OptionType => opt !== null);

  return defaultOption ? [defaultOption, ...mappedOptions] : mappedOptions;
};

export const decodeHTMLEntities = (text: string): string => {
  return text
    .replace(/\r?\n/g, "\\n")
    .replace(/&amp;/g, "&")
    .replace(/&gt;/g, ">")
    .replace(/&lt;/g, "<")
    .replace(/&nbsp;/g, " ");
    // .replace(/&quot;/g, '"')
    // .replace(/&#039;/g, "'")
    // .replace(/&apos;/g, "'")
    // .replace(/&cent;/g, "¢")
    // .replace(/&pound;/g, "£")
    // .replace(/&yen;/g, "¥")
    // .replace(/&euro;/g, "€")
    // .replace(/&copy;/g, "©")
    // .replace(/&reg;/g, "®")
}

//only require if form remain open after creating/update record
export const setNewlyCreatedId = async (
  response: any,
  keyId: string,
  entityName: string,
  setKeyId: (value: string) => void,
  setActiveId: (value: number) => void,
  setFormData: (value: any) => void
): Promise<{ id: number; key: string }> => {
  if (keyId === Code.Key.NEW) {
    const localKeyId = response.data[Code.Key.NEWID];
    const localNewId = Extract.Key.Decode(localKeyId);

    //console.log("setNewlyCreatedId:", {localKeyId, localNewId});
    
    setKeyId(localKeyId); 
    setActiveId(Code.Option.Active.ACTIVE); 
    setFormData((prev: any) => ({
      ...prev,
      [`${entityName}_id`]: localNewId,
      [`${entityName}_key`]: localKeyId,
    }));
    
    return { id: localNewId, key: localKeyId };
  }
  
  return { id: 0, key: '' }; // Return default value if condition isn't met
};

const toggleActiveStatus = (activeId?: number): number => {
    return activeId === Code.Option.Active.ACTIVE
        ? Code.Option.Active.DELETE
        : Code.Option.Active.ACTIVE;
  };

const MessageWarning = (message: string[], setMessage: Dispatch<SetStateAction<MessageType>>) => {
  setMessage({
    messages: message,
    type: Code.Message.type.WARNING
  });
};

const MessageError = (message: string[], setMessage: Dispatch<SetStateAction<MessageType>>) => {
  setMessage({
    messages: message,
    type: Code.Message.type.ERROR
  });
};

const MessageInfo = (message: string[], setMessage: Dispatch<SetStateAction<MessageType>>) => {
  setMessage({
    messages: message,
    type: Code.Message.type.INFO
  });
};

const MessageConfirmation = (message: string[], setMessage: Dispatch<SetStateAction<MessageType>>) => {
  setMessage({
    messages: message,
    type: Code.Message.type.CONFIRMTION
  });
};

const MessageMissing = (message: string[], setMessage: Dispatch<SetStateAction<MessageType>>) => {
  setMessage({
    messages: message,
    type: Code.Message.type.EMPTY_FIELDS
  });
};

function extractModelFields<T extends object>(formData: any, keys: (keyof T)[]): Partial<T> {
  const keySet = new Set(keys);
  const modelData: Partial<T> = {};

  Object.keys(formData).forEach((key) => {
    if (keySet.has(key as keyof T)) {
      (modelData as any)[key] = formData[key];
    }
  });

  return modelData;
}

function reverseCalculate(input: ItemInventory): ItemCalculate {
  let price = Number(input.item_price) || 0;
  let quantity = Number(input.item_quantity) || 0;
  let discountPercentage = Number(input.item_discount_percentage) || 0;
  let discountAmount = Number(input.item_discount_amount) || 0;
  let taxPercentage = Number(input.item_tax1_percentage) || 0;
  let netAmount = Number(input.item_net_amount) || 0;

  quantity = quantity <= 0 ? 1 : quantity;

  let taxableAmount = 0;
  let grossAmount = 0;
  let taxAmount = 0;

  if (price === 0) {
    // CASE 1: price not given
    if (discountPercentage > 0 && taxPercentage > 0) {
      const factor = (1 - discountPercentage / 100) * (1 + taxPercentage / 100);
      grossAmount = netAmount / factor;
      discountAmount = (grossAmount * discountPercentage) / 100;
      const taxableAmount = grossAmount - discountAmount;
      taxAmount = (taxableAmount * taxPercentage) / 100;
      price = grossAmount / quantity;
    } else if (discountPercentage > 0 && taxPercentage === 0) {
      grossAmount = netAmount / (1 - discountPercentage / 100);
      discountAmount = grossAmount - netAmount;
      taxAmount = 0;
      price = grossAmount / quantity;
    } else if (discountAmount > 0) {
      const taxableAmount = netAmount / (1 + taxPercentage / 100);
      grossAmount = taxableAmount + discountAmount;
      discountPercentage = (discountAmount / grossAmount) * 100;
      taxAmount = netAmount - taxableAmount;
      price = grossAmount / quantity;
    } else {
      discountAmount = 0;
      discountPercentage = 0;
      if (taxPercentage > 0) {
        const taxableAmount = netAmount / (1 + taxPercentage / 100);
        taxAmount = netAmount - taxableAmount;
        grossAmount = taxableAmount;
        price = grossAmount / quantity;
      } else {
        grossAmount = netAmount;
        taxAmount = 0;
        price = grossAmount / quantity;
      }
    }
  } else {
    // CASE 2: price is known
    grossAmount = price * quantity;

    const taxableTarget = netAmount / (1 + taxPercentage / 100);
    discountAmount = grossAmount - taxableTarget;
    discountPercentage = (discountAmount / grossAmount) * 100;

    const taxableAmount = grossAmount - discountAmount;
    taxAmount = taxableAmount * (taxPercentage / 100);
  }

  return {
    priceAmount: parseFloat(price.toFixed(2)),
    quantity: quantity,
    grossAmount: parseFloat(grossAmount.toFixed(2)),
    discountAmount: parseFloat(discountAmount.toFixed(2)),
    discountPercentage: parseFloat(discountPercentage.toFixed(2)),
    taxableAmount: parseFloat(taxableAmount.toFixed(2)),
    taxPercentage: parseFloat(taxPercentage.toFixed(2)),
    taxAmount: parseFloat(taxAmount.toFixed(2)),
    netAmount: parseFloat(netAmount.toFixed(2)),
  };
}

function calculateItem(input: ItemInventory): ItemCalculate {
  let priceAmount = Number(input.item_price) || 0;
  let quantity = Number(input.item_quantity) || 0;
  let grossAmount = Number(input.item_gross_amount) || 0;
  let taxableAmount = Number(input.item_taxable_amount) || 0;
  let discountPercentage = Number(input.item_discount_percentage) || 0;
  let discountAmount = Number(input.item_discount_amount) || 0;
  let taxPercentage = Number(input.item_tax1_percentage) || 0;
  let taxAmount = Number(input.item_tax1_amount) || 0;
  let netAmount = Number(input.item_net_amount) || 0;
  let rawAmount = 0;

  if(priceAmount > 0 && quantity!=0) {
    grossAmount = parseFloat((priceAmount * quantity).toFixed(2));
    rawAmount = grossAmount;
    taxableAmount = grossAmount;
  }
  
  if(grossAmount!=0) {
  if(discountPercentage > 0) discountAmount = parseFloat(((grossAmount * discountPercentage) / 100).toFixed(2));
    if(discountAmount!=0) taxableAmount = parseFloat((grossAmount - discountAmount).toFixed(2));
    rawAmount = taxableAmount;
    if(taxPercentage>0) taxAmount = parseFloat(((taxableAmount * taxPercentage) / 100).toFixed(2));
    if(taxAmount!=0) rawAmount = parseFloat((taxableAmount + taxAmount).toFixed(2));
  }

  netAmount = rawAmount;
  
  const roundNetAmount = roundOffDecimal(netAmount);
  if(roundNetAmount !== netAmount){
    const diff  = parseFloat((netAmount - roundNetAmount).toFixed(2));
    netAmount = roundNetAmount;
  }

  return {
    priceAmount: parseFloat(priceAmount.toFixed(2)),
    quantity: quantity,
    grossAmount: parseFloat(grossAmount.toFixed(2)),
    discountAmount: parseFloat(discountAmount.toFixed(2)),
    discountPercentage: parseFloat(discountPercentage.toFixed(2)),
    taxableAmount: parseFloat(taxableAmount.toFixed(2)),
    taxPercentage: parseFloat(taxPercentage.toFixed(2)),
    taxAmount: parseFloat(taxAmount.toFixed(2)),
    netAmount: parseFloat(netAmount.toFixed(2)),
  };
}

function calculateSaleItem(input: SaleItem): ItemCalculate {
  let priceAmount = Number(input.saleitem_price) || 0;
  let quantity = Number(input.saleitem_quantity) || 0;
  let grossAmount = Number(input.saleitem_gross_amount) || 0;
  let taxableAmount = Number(input.saleitem_taxable_amount) || 0;
  let discountPercentage = Number(input.saleitem_discount_percentage) || 0;
  let discountAmount = Number(input.saleitem_discount_amount) || 0;
  let taxPercentage = Number(input.saleitem_tax1_percentage) || 0;
  let taxAmount = Number(input.saleitem_tax1_amount) || 0;
  let netAmount = Number(input.saleitem_net_amount) || 0;
  let rawAmount = 0;

  if(priceAmount != 0 && quantity!=0) {
    grossAmount = parseFloat((priceAmount * quantity).toFixed(2));
    rawAmount = grossAmount;
    taxableAmount = grossAmount;
  }
  
  if(grossAmount!=0) {
  if(discountPercentage > 0) discountAmount = parseFloat(((grossAmount * discountPercentage) / 100).toFixed(2));
    if(discountAmount!=0) taxableAmount = parseFloat((grossAmount - discountAmount).toFixed(2));
    rawAmount = taxableAmount;
    if(taxPercentage>0) taxAmount = parseFloat(((taxableAmount * taxPercentage) / 100).toFixed(2));
    if(taxAmount!=0) rawAmount = parseFloat((taxableAmount + taxAmount).toFixed(2));
  }

  netAmount = rawAmount;
  
  const roundNetAmount = roundOffDecimal(netAmount);
  if(roundNetAmount !== netAmount){
    const diff  = parseFloat((netAmount - roundNetAmount).toFixed(2));
    netAmount = roundNetAmount;
  }

  return {
    priceAmount: parseFloat(priceAmount.toFixed(2)),
    quantity: quantity,
    grossAmount: parseFloat(grossAmount.toFixed(2)),
    discountAmount: parseFloat(discountAmount.toFixed(2)),
    discountPercentage: parseFloat(discountPercentage.toFixed(2)),
    taxableAmount: parseFloat(taxableAmount.toFixed(2)),
    taxPercentage: parseFloat(taxPercentage.toFixed(2)),
    taxAmount: parseFloat(taxAmount.toFixed(2)),
    netAmount: parseFloat(netAmount.toFixed(2)),
  };
}

function calculatePrice(input: ItemInventory): ItemCalculate {
  let priceAmount = Number(input.item_price) || 0;
  let quantity = Number(input.item_quantity) || 0;
  let discountPercentage = Number(input.item_discount_percentage) || 0;
  let discountAmount = Number(input.item_discount_amount) || 0;
  let taxPercentage = Number(input.item_tax1_percentage) || 0;
  let netAmount = Number(input.item_net_amount) || 0;

  quantity = quantity <= 0 ? 1 : quantity;

  let taxableAmount = 0;
  let grossAmount = 0;
  let taxAmount = 0;

  if (discountPercentage > 0 && taxPercentage > 0) {
    const factor = (1 - discountPercentage / 100) * (1 + taxPercentage / 100);
    grossAmount = netAmount / factor;
    discountAmount = (grossAmount * discountPercentage) / 100;
    taxableAmount = grossAmount - discountAmount;
    taxAmount = (taxableAmount * taxPercentage) / 100;
    priceAmount = grossAmount / quantity;
  } else if (discountPercentage > 0 && taxPercentage === 0) {
    grossAmount = netAmount / (1 - discountPercentage / 100);
    discountAmount = grossAmount - netAmount;
    taxAmount = 0;
    priceAmount = grossAmount / quantity;
  } else if (discountAmount > 0) {
    taxableAmount = netAmount / (1 + taxPercentage / 100);
    grossAmount = taxableAmount + discountAmount;
    discountPercentage = (discountAmount / grossAmount) * 100;
    taxAmount = netAmount - taxableAmount;
    priceAmount = grossAmount / quantity;
  } else {
    discountAmount = 0;
    discountPercentage = 0;
    if (taxPercentage > 0) {
      taxableAmount = netAmount / (1 + taxPercentage / 100);
      taxAmount = netAmount - taxableAmount;
      grossAmount = taxableAmount;
      priceAmount = grossAmount / quantity;
    } else {
      grossAmount = netAmount;
      taxAmount = 0;
      priceAmount = grossAmount / quantity;
    }
  }

  return {
    priceAmount: parseFloat(priceAmount.toFixed(2)),
    quantity: quantity,
    grossAmount: parseFloat(grossAmount.toFixed(2)),
    discountAmount: parseFloat(discountAmount.toFixed(2)),
    discountPercentage: parseFloat(discountPercentage.toFixed(2)),
    taxableAmount: parseFloat(taxableAmount.toFixed(2)),
    taxPercentage: parseFloat(taxPercentage.toFixed(2)),
    taxAmount: parseFloat(taxAmount.toFixed(2)),
    netAmount: parseFloat(netAmount.toFixed(2)),
  };
}

function calculateDiscount(input: ItemInventory): ItemCalculate {
  let priceAmount = Number(input.item_price) || 0;
  let quantity = Number(input.item_quantity) || 0;
  let grossAmount = Number(input.item_gross_amount) || 0;
  let discountPercentage = Number(input.item_discount_percentage) || 0;
  let discountAmount = Number(input.item_discount_amount) || 0;
  let taxPercentage = Number(input.item_tax1_percentage) || 0;
  let taxAmount = Number(input.item_tax1_amount) || 0;
  let netAmount = Number(input.item_net_amount) || 0;

  quantity = quantity == 0 ? 1 : quantity;

  grossAmount = priceAmount * quantity;

  const taxableTarget = netAmount / (1 + taxPercentage / 100);
  discountAmount = grossAmount - taxableTarget;
  discountPercentage = (discountAmount / grossAmount) * 100;

  const taxableAmount = grossAmount - discountAmount;
  taxAmount = taxableAmount * (taxPercentage / 100);

  return {
    priceAmount: parseFloat(priceAmount.toFixed(2)),
    quantity: quantity,
    grossAmount: parseFloat(grossAmount.toFixed(2)),
    discountPercentage: parseFloat(discountPercentage.toFixed(2)),
    discountAmount: parseFloat(discountAmount.toFixed(2)),
    taxableAmount: parseFloat(taxableAmount.toFixed(2)),
    taxPercentage: parseFloat(taxPercentage.toFixed(2)),
    taxAmount: parseFloat(taxAmount.toFixed(2)),
    netAmount: parseFloat(netAmount.toFixed(2)),
  };
}

function roundOffDecimal(amount: number): number {
  const decimal = parseFloat((amount % 1).toFixed(2)); 

  if (decimal === 0.99 || decimal === 0.98 || decimal === 0.01 || decimal === 0.02) {
    return Math.round(amount);
  }

  return amount;
}

function RemoveNA(data: string | undefined): string {
  return data?.replace(Code.Option.Title.NA,'') || '';
}

function CleanSQL(sql: string | undefined): string {
  return sql?.replaceAll("&gt;",">").replaceAll("&lt;","<") || '';
}

const constExplanatoryToId: Record<string, number> = {
  "1": 10, "01A": 11, "01C": 12, "2": 13, "3": 14, "4": 15, "04A": 16,
  "5": 17, "05A": 18, "05AA": 19, "05B": 20, "05BA": 21, "05BB": 22, "05C": 23,
  "6": 24, "7": 25, "8": 26, "9": 27, "10": 28, "10A": 29, "10AA": 30,
  "11": 31, "20": 32, "20A": 33, "20AB": 34, "20B": 35, "20C": 36, "20D": 37,
  "20E": 38, "20F": 39, "21": 40, "21AB": 41, "22": 42, "23A": 43, "25": 44,
  "25A": 45, "28": 46, "30": 47, "30A": 48, "30AA": 49, "30AB": 50, "30AC": 51,
  "30B": 52, "30BA": 53, "30E": 54, "30EA": 55, "30EB": 56, "30F": 57, "30G": 58,
  "30H": 59, "31": 60, "31A": 61, "34AA": 62, "34AB": 63, "34AC": 64, "34AD": 65,
  "34B": 66, "34C": 67, "34DA": 68, "34DB": 69, "34DC": 70, "34DD": 71, "34DE": 72,
  "34DF": 73, "34DG": 74, "34DH": 75, "34EA": 76, "34EB": 77, "34EC": 78, "34ED": 79,
  "34F": 80, "35A": 81, "35B": 82, "35C": 83, "35D": 84, "35E": 85, "35F": 86,
  "35FA": 87, "35FB": 88, "35FC": 89, "35G": 90, "35H": 91, "35J": 92, "35K": 93,
  "35KA": 94, "35L": 95, "35M": 96, "36": 97, "36A": 98, "37": 99, "37A": 100,
  "37B": 101, "39": 102, "39A": 103, "39B": 104, "39BA": 105, "39BB": 106, "39BC": 107,
  "39BD": 108, "39BE": 109, "39D": 110, "39DA": 111, "39DB": 112, "39DC": 113, "39DD": 114,
  "39DE": 115, "39EB": 116, "39EC": 117, "39F": 118, "39FA": 119, "39G": 120, "39H": 121,
  "41": 122, "41B": 123, "42": 124, "43": 125, "45": 126, "45A": 127, "45AA": 128,
  "45B": 129, "47": 130, "48": 131, "49": 132, "50": 133, "50A": 134, "50AA": 135,
  "50AB": 136, "50B": 137, "50BA": 138, "50BB": 139, "50BC": 140, "51": 141, "51A": 142,
  "51G": 143, "52A": 144, "52B": 145, "54": 146, "54A": 147, "54B": 148, "56": 149,
  "56A": 150, "56B": 151, "56C": 152, "56D": 153, "53D": 154, "58": 155, "58A": 156,
  "58B": 157, "58BA": 158, "58C": 159, "58E": 160, "58F": 161, "60": 162, "60A": 163,
  "60AA": 164, "60B": 165, "60C": 166, "60E": 167, "60EA": 168, "60EB": 169, "60EC": 170,
  "60ED": 171, "61": 172, "61A": 173, "61B": 174, "61C": 175, "61CA": 176, "61CB": 177,
  "61E": 178, "61EA": 179, "61F": 180, "61G": 181, "61H": 182, "62": 183, "63": 184,
  "63A": 185, "63AA": 186, "63AC": 187, "63B": 188, "63C": 189, "64": 190, "64AA": 191,
  "64AB": 192, "64C": 193, "64D": 194, "64E": 195, "65": 196, "65A": 197, "65AA": 198,
  "65D": 199, "65E": 200, "66": 201, "66A": 202, "67": 203, "67A": 204, "67AA": 205,
  "67AB": 206, "67AC": 207, "67AD": 208, "67AE": 209, "67B": 210, "69": 211, "70": 212,
  "70A": 213, "70D": 214, "70E": 215, "70EA": 216, "70EB": 217, "70F": 218, "70G": 219,
  "70J": 220, "70K": 221, "70L": 222, "73": 223, "73A": 224, "73BA": 225, "73BB": 226,
  "73BC": 227, "73BD": 228, "73BE": 229, "80": 230, "80B": 231, "BA": 232, "80BD": 233,
  "80BE": 234, "80BF": 235, "80BH": 236, "80C": 237, "80D": 238, "80F": 239, "80G": 240,
  "80H": 241, "80J": 242, "80K": 243, "80L": 244, "90": 245, "90A": 246, "90D": 247,
  "90E": 248, "95": 249, "95A": 250, "95B": 251, "95C": 252, "95D": 253, "95E": 254,
  "95F": 255, "95G": 256, "95K": 257, "95L": 258, "95M": 259, "95T": 260, "96B": 261,
  "96C": 262, "96D": 263, "96E": 264, "96F": 265, "96G": 266, "96H": 267, "98": 268,
  "98A": 269, "98AA": 270, "98C": 271, "98D": 272, "98DA": 273, "98DB": 274, "98DC": 275,
  "98E": 276, "98EA": 277, "98EB": 278,
};

function ExplanatoryToId(code: string): number {
  return code ? constExplanatoryToId[code.toUpperCase()] ?? 2 : 2;
}

function GetFormName(formNo: number | undefined): string {
  if(formNo){
    switch (formNo) {
      case Code.Form.Id.INVOICE: return "Invoice";
      case Code.Form.Id.ORDERS: return "Order";
      case Code.Form.Id.PROFORMA: return "Proforma";
      case Code.Form.Id.PURCHASE: return "Purchase";
      case Code.Form.Id.DISPENSE: return "Dispense";
      case Code.Form.Id.RELEASE: return "Release";
      case Code.Form.Id.ESTIMATE: return "Estimate";
      case Code.Form.Id.STOCK: return "Stock";
      case Code.Form.Id.STOCKIN: return "Stock In";
      case Code.Form.Id.STOCKOUT: return "Stock Out";
      case Code.Form.Id.ISSUE: return "Issue";
      case Code.Form.Id.SALERETURN: return "Sale Return";
      case Code.Form.Id.EXAMTEMPLATE: return "Exam Template";
      case Code.Form.Id.PURCHASERETURN: return "Puchase Return";
      case Code.Form.Id.TOORDER: return "To Order";
      case Code.Form.Id.ONORDER: return "On Order";
      case Code.Form.Id.CREDITRECEIVED: return "Credit Received";
      case Code.Form.Id.CREDITPENDING: return "Credit Pending";
      case Code.Form.Id.CREDITCANCEL: return "Credit Cancel";
      case Code.Form.Id.LOST: return "Lost/Missing";
      case Code.Form.Id.TRANSFERIN: return "Transfer In";
      case Code.Form.Id.TRANSFEROUT: return "Transfer Out";
      case Code.Form.Id.DAMAGED: return "Damaged";
      case Code.Form.Id.REQUISITION: return "Requisition";
      case Code.Form.Id.DELIVERY: return "Delivery";
      default: return "";
    }
  }
  return '';
}

const getFormFullName = (name?: string): string => {
  switch (name) {
    case "examtemplate":
      return "Exam Template";
    case "examtype":
      return "Exam Type";
    case "salereturn":
      return "Sale Return";
    case "purchaseorder":
      return "Purchase Order";
    case "purchasereturn":
      return "Purchase Return";
    case "purchasecredit":
      return "Purchase Credit";
    case "recdoctor":
      return "Recipient";
    default:
      return name || "";
  }
};

// const getFormShortName = (value?: number, length?: number): string => {
//   let formName = '';

//   switch (value) {
//     case Code.Form.Id.INVOICE:
//       formName = "Invoice";
//       break;
//     case Code.Form.Id.RELEASE:
//       formName = "Release";
//       break;
//     case Code.Form.Id.PROFORMA:
//       formName = "Proforma";
//       break;
//     default:
//       formName = '';
//   }

//   if (length && length > 0) {
//     formName = formName.substring(0, length);
//   }

//   return formName;
// };

function GetFormLink(formNo: number | undefined, common_id:number | undefined, item_id:number | undefined): string {
  if(formNo){
    switch (formNo) {
      case Code.Form.Id.INVOICE: return `invoice/${common_id}`;
      case Code.Form.Id.ORDERS: return `orders/${common_id}`;
      case Code.Form.Id.PROFORMA: return `proforma/${common_id}`;
      case Code.Form.Id.RELEASE: return `release/${common_id}`;
      case Code.Form.Id.PURCHASE: return `purchase/${common_id}`;
      case Code.Form.Id.DISPENSE: return `dispense/${common_id}`;
      case Code.Form.Id.ESTIMATE: return `estimate/${common_id}`;
      case Code.Form.Id.SALERETURN: return `salereturn/${common_id}`;
      case Code.Form.Id.CREDITRECEIVED: return `purchasecredit/${common_id}`;
      case Code.Form.Id.CREDITPENDING: return `purchasereturn/${common_id}`;
      case Code.Form.Id.CREDITCANCEL: return `stock/${common_id}`;
      case Code.Form.Id.LOST: return `stock/${common_id}`;
      case Code.Form.Id.TRANSFERIN: return `stock/${common_id}`;
      case Code.Form.Id.TRANSFEROUT: return `stock/${common_id}`;
      case Code.Form.Id.DAMAGED: return `stock/${common_id}`;
      case Code.Form.Id.REQUISITION: return `requisition/${common_id}`;
      case Code.Form.Id.DELIVERY: return `delivery/${common_id}`;
      default: return "";
    }
  }
  return '';
}

function GetGroupMapFields(GroupId: number): GroupMapData {
  if(GroupId){
    switch (GroupId) {
      case Code.Exam.GroupId.Habitual:  
        return { 
          ODSphere: EMF.Habitual.ODSphere, 
          OSSphere: EMF.Habitual.OSSphere, 
          ODCylinder: EMF.Habitual.ODCylinder, 
          OSCylinder: EMF.Habitual.OSCylinder,
          ODAxis: EMF.Habitual.ODAxis,
          OSAxis: EMF.Habitual.OSAxis,
          ODAdd: EMF.Habitual.ODAdd,
          OSAdd: EMF.Habitual.OSAdd,
          ODPd: EMF.Habitual.ODPD,
          OSPd: EMF.Habitual.OSPD,
          ODAcuity: EMF.Habitual.ODAcuity,
          OSAcuity: EMF.Habitual.OSAcuity,
          OUAcuity: EMF.Habitual.OUAcuity,

          ODPrism: EMF.Habitual.ODPrism,
          ODOrient: EMF.Habitual.ODOrient,
          OSPrism: EMF.Habitual.OSPrism,
          OSOrient: EMF.Habitual.OSOrient,
          ODPrism2: EMF.Habitual.ODPrism2,
          ODOrient2: EMF.Habitual.ODOrient2,
          OSPrism2: EMF.Habitual.OSPrism2,
          OSOrient2: EMF.Habitual.OSOrient2,

          Lens: EMF.Habitual.Lens,
          MatteTinted: EMF.Habitual.MatteTinted,
          Method: EMF.Habitual.Method,
          Notes: EMF.Habitual.Notes,
          RxDate: EMF.Habitual.RxDate,
          RxExpiry: EMF.Habitual.RxExpiry,
      };
      case Code.Exam.GroupId.Habitual2:  
        return { 
          ODSphere: EMF.Habitual2.ODSphere, 
          OSSphere: EMF.Habitual2.OSSphere, 
          ODCylinder: EMF.Habitual2.ODCylinder, 
          OSCylinder: EMF.Habitual2.OSCylinder, 
          ODAxis: EMF.Habitual2.ODAxis,
          OSAxis: EMF.Habitual2.OSAxis,
          ODAdd: EMF.Habitual2.ODAdd,
          OSAdd: EMF.Habitual2.OSAdd,
          ODPd: EMF.Habitual2.ODPd,
          OSPd: EMF.Habitual2.OSPd,
          ODAcuity: EMF.Habitual2.ODAcuity,
          OSAcuity: EMF.Habitual2.OSAcuity,
          OUAcuity: EMF.Habitual2.OUAcuity,

          ODPrism: EMF.Habitual2.ODPrism,
          ODOrient: EMF.Habitual2.ODOrient,
          OSPrism: EMF.Habitual2.OSPrism,
          OSOrient: EMF.Habitual2.OSOrient,
          ODPrism2: EMF.Habitual2.ODPrism2,
          ODOrient2: EMF.Habitual2.ODOrient2,
          OSPrism2: EMF.Habitual2.OSPrism2,
          OSOrient2: EMF.Habitual2.OSOrient2,

          Lens: EMF.Habitual2.Lens,
          MatteTinted: EMF.Habitual2.MatteTinted,
          Method: EMF.Habitual2.Method,
          Notes: EMF.Habitual2.Notes,
          RxDate: EMF.Habitual2.RxDate,
          RxExpiry: EMF.Habitual2.RxExpiry,
        };
      case Code.Exam.GroupId.Habitual3:  
        return { 
          ODSphere: EMF.Habitual3.ODSphere, 
          OSSphere: EMF.Habitual3.OSSphere, 
          ODCylinder: EMF.Habitual3.ODCylinder, 
          OSCylinder: EMF.Habitual3.OSCylinder, 
          ODAxis: EMF.Habitual3.ODAxis,
          OSAxis: EMF.Habitual3.OSAxis,
          ODAdd: EMF.Habitual3.ODAdd,
          OSAdd: EMF.Habitual3.OSAdd,
          ODPd: EMF.Habitual3.ODPd,
          OSPd: EMF.Habitual3.OSPd,
          ODAcuity: EMF.Habitual3.ODAcuity,
          OSAcuity: EMF.Habitual3.OSAcuity,
          OUAcuity: EMF.Habitual3.OUAcuity,

          ODPrism: EMF.Habitual3.ODPrism,
          ODOrient: EMF.Habitual3.ODOrient,
          OSPrism: EMF.Habitual3.OSPrism,
          OSOrient: EMF.Habitual3.OSOrient,
          ODPrism2: EMF.Habitual3.ODPrism2,
          ODOrient2: EMF.Habitual3.ODOrient2,
          OSPrism2: EMF.Habitual3.OSPrism2,
          OSOrient2: EMF.Habitual3.OSOrient2,

          Lens: EMF.Habitual3.Lens,
          MatteTinted: EMF.Habitual3.MatteTinted,
          Method: EMF.Habitual3.Method,
          Notes: EMF.Habitual3.Notes,
          RxDate: EMF.Habitual3.RxDate,
          RxExpiry: EMF.Habitual3.RxExpiry,
        };
      case Code.Exam.GroupId.FinalRx:  
        return { 
          ODSphere: EMF.FinalRx.ODSphere,  
          OSSphere: EMF.FinalRx.OSSphere, 
          ODCylinder: EMF.FinalRx.ODCylinder, 
          OSCylinder: EMF.FinalRx.OSCylinder,
          ODAxis: EMF.FinalRx.ODAxis,
          OSAxis: EMF.FinalRx.OSAxis,
          ODAdd: EMF.FinalRx.ODAdd,
          OSAdd: EMF.FinalRx.OSAdd,
          ODPd: EMF.FinalRx.ODPd,
          OSPd: EMF.FinalRx.OSPd,
          ODAcuity: EMF.FinalRx.ODAcuity,
          OSAcuity: EMF.FinalRx.OSAcuity,
          OUAcuity: EMF.FinalRx.OUAcuity,

          ODPrism: EMF.FinalRx.ODPrism,
          ODOrient: EMF.FinalRx.ODOrient,
          OSPrism: EMF.FinalRx.OSPrism,
          OSOrient: EMF.FinalRx.OSOrient,
          ODPrism2: EMF.FinalRx.ODPrism2,
          ODOrient2: EMF.FinalRx.ODOrient2,
          OSPrism2: EMF.FinalRx.OSPrism2,
          OSOrient2: EMF.FinalRx.OSOrient2,

          Lens: EMF.FinalRx.Lens,
          MatteTinted: EMF.FinalRx.MatteTinted,
          Method: EMF.FinalRx.Method,
          Notes: EMF.FinalRx.Notes,
          RxDate: EMF.FinalRx.RxDate,
          RxExpiry: EMF.FinalRx.RxExpiry, 
        }  
      case Code.Exam.GroupId.FinalRx2:  
        return { 
          ODSphere: EMF.FinalRx2.ODSphere,  
          OSSphere: EMF.FinalRx2.OSSphere, 
          ODCylinder: EMF.FinalRx2.ODCylinder, 
          OSCylinder: EMF.FinalRx2.OSCylinder,
          ODAxis: EMF.FinalRx2.ODAxis,
          OSAxis: EMF.FinalRx2.OSAxis,
          ODAdd: EMF.FinalRx2.ODAdd,
          OSAdd: EMF.FinalRx2.OSAdd,
          ODPd: EMF.FinalRx2.ODPd,
          OSPd: EMF.FinalRx2.OSPd,
          ODAcuity: EMF.FinalRx2.ODAcuity,
          OSAcuity: EMF.FinalRx2.OSAcuity,
          OUAcuity: EMF.FinalRx2.OUAcuity,

          ODPrism: EMF.FinalRx2.ODPrism,
          ODOrient: EMF.FinalRx2.ODOrient,
          OSPrism: EMF.FinalRx2.OSPrism,
          OSOrient: EMF.FinalRx2.OSOrient,
          ODPrism2: EMF.FinalRx2.ODPrism2,
          ODOrient2: EMF.FinalRx2.ODOrient2,
          OSPrism2: EMF.FinalRx2.OSPrism2,
          OSOrient2: EMF.FinalRx2.OSOrient2,

          Lens: EMF.FinalRx2.Lens,
          MatteTinted: EMF.FinalRx2.MatteTinted,
          Method: EMF.FinalRx2.Method,
          Notes: EMF.FinalRx2.Notes,
          RxDate: EMF.FinalRx2.RxDate,
          RxExpiry: EMF.FinalRx2.RxExpiry,  
        }
      case Code.Exam.GroupId.FinalRx3:  
        return { 
          ODSphere: EMF.FinalRx3.ODSphere,  
          OSSphere: EMF.FinalRx3.OSSphere, 
          ODCylinder: EMF.FinalRx3.ODCylinder, 
          OSCylinder: EMF.FinalRx3.OSCylinder,
          ODAxis: EMF.FinalRx3.ODAxis,
          OSAxis: EMF.FinalRx3.OSAxis,
          ODAdd: EMF.FinalRx3.ODAdd,
          OSAdd: EMF.FinalRx3.OSAdd,
          ODPd: EMF.FinalRx3.ODPd,
          OSPd: EMF.FinalRx3.OSPd,
          ODAcuity: EMF.FinalRx3.ODAcuity,
          OSAcuity: EMF.FinalRx3.OSAcuity,
          OUAcuity: EMF.FinalRx3.OUAcuity,

          ODPrism: EMF.FinalRx3.ODPrism,
          ODOrient: EMF.FinalRx3.ODOrient,
          OSPrism: EMF.FinalRx3.OSPrism,
          OSOrient: EMF.FinalRx3.OSOrient,
          ODPrism2: EMF.FinalRx3.ODPrism2,
          ODOrient2: EMF.FinalRx3.ODOrient2,
          OSPrism2: EMF.FinalRx3.OSPrism2,
          OSOrient2: EMF.FinalRx3.OSOrient2,

          Lens: EMF.FinalRx3.Lens,
          MatteTinted: EMF.FinalRx3.MatteTinted,
          Method: EMF.FinalRx3.Method,
          Notes: EMF.FinalRx3.Notes,
          RxDate: EMF.FinalRx3.RxDate,
          RxExpiry: EMF.FinalRx3.RxExpiry,  
        }
      case Code.Exam.GroupId.CLTrial:  
        return { 
          ODSphere: EMF.CLTrial1.ODSphere,  
          OSSphere: EMF.CLTrial1.OSSphere, 
          ODCylinder: EMF.CLTrial1.ODCylinder, 
          OSCylinder: EMF.CLTrial1.OSCylinder,
          ODAxis: EMF.CLTrial1.ODAxis,
          OSAxis: EMF.CLTrial1.OSAxis,
          ODAdd: EMF.CLTrial1.ODAdd,
          OSAdd: EMF.CLTrial1.OSAdd,
          ODSupplier: EMF.CLTrial1.ODSupplier,
          OSSupplier: EMF.CLTrial1.OSSupplier,
          ODType: EMF.CLTrial1.ODType,
          OSType: EMF.CLTrial1.OSType,
          ODName: EMF.CLTrial1.ODName,
          OSName: EMF.CLTrial1.OSName,
          ODColor: EMF.CLTrial1.ODColor,
          OSColor: EMF.CLTrial1.OSColor,
          ODPack: EMF.CLTrial1.ODPack,
          OSPack: EMF.CLTrial1.OSPack,
          ODBc: EMF.CLTrial1.ODBc,
          OSBc: EMF.CLTrial1.OSBc,
          ODDia: EMF.CLTrial1.ODDia,
          OSDia: EMF.CLTrial1.OSDia,
          Status: EMF.CLTrial1.Status,
          ExpiryDate: EMF.CLTrial1.ExpiryDate,
          FittingNote: EMF.CLTrial1.FittingNote,
          Solution: EMF.CLTrial1.Solution,
          Notes: EMF.CLTrial1.Notes,
        }
      case Code.Exam.GroupId.CLTrial2:  
        return { 
          ODSphere: EMF.CLTrial2.ODSphere,  
          OSSphere: EMF.CLTrial2.OSSphere, 
          ODCylinder: EMF.CLTrial2.ODCylinder, 
          OSCylinder: EMF.CLTrial2.OSCylinder,
          ODAxis: EMF.CLTrial2.ODAxis,
          OSAxis: EMF.CLTrial2.OSAxis,
          ODAdd: EMF.CLTrial2.ODAdd,
          OSAdd: EMF.CLTrial2.OSAdd,
          ODSupplier: EMF.CLTrial2.ODSupplier,
          OSSupplier: EMF.CLTrial2.OSSupplier,
          ODType: EMF.CLTrial2.ODType,
          OSType: EMF.CLTrial2.OSType,
          ODName: EMF.CLTrial2.ODName,
          OSName: EMF.CLTrial2.OSName,
          ODColor: EMF.CLTrial2.ODColor,
          OSColor: EMF.CLTrial2.OSColor,
          ODPack: EMF.CLTrial2.ODPack,
          OSPack: EMF.CLTrial2.OSPack,
          ODBc: EMF.CLTrial2.ODBc,
          OSBc: EMF.CLTrial2.OSBc,
          ODDia: EMF.CLTrial2.ODDia,
          OSDia: EMF.CLTrial2.OSDia,
          Status: EMF.CLTrial2.Status,
          ExpiryDate: EMF.CLTrial2.ExpiryDate,
          FittingNote: EMF.CLTrial2.FittingNote,
          Solution: EMF.CLTrial2.Solution,
          Notes: EMF.CLTrial2.Notes,
        }
      case Code.Exam.GroupId.CLTrial3:  
        return { 
          ODSphere: EMF.CLTrial3.ODSphere,  
          OSSphere: EMF.CLTrial3.OSSphere, 
          ODCylinder: EMF.CLTrial3.ODCylinder, 
          OSCylinder: EMF.CLTrial3.OSCylinder,
          ODAxis: EMF.CLTrial3.ODAxis,
          OSAxis: EMF.CLTrial3.OSAxis,
          ODAdd: EMF.CLTrial3.ODAdd,
          OSAdd: EMF.CLTrial3.OSAdd,
          ODSupplier: EMF.CLTrial3.ODSupplier,
          OSSupplier: EMF.CLTrial3.OSSupplier,
          ODType: EMF.CLTrial3.ODType,
          OSType: EMF.CLTrial3.OSType,
          ODName: EMF.CLTrial3.ODName,
          OSName: EMF.CLTrial3.OSName,
          ODColor: EMF.CLTrial3.ODColor,
          OSColor: EMF.CLTrial3.OSColor,
          ODPack: EMF.CLTrial3.ODPack,
          OSPack: EMF.CLTrial3.OSPack,
          ODBc: EMF.CLTrial3.ODBc,
          OSBc: EMF.CLTrial3.OSBc,
          ODDia: EMF.CLTrial3.ODDia,
          OSDia: EMF.CLTrial3.OSDia,
          Status: EMF.CLTrial3.Status,
          ExpiryDate: EMF.CLTrial3.ExpiryDate,
          FittingNote: EMF.CLTrial3.FittingNote,
          Solution: EMF.CLTrial3.Solution,
          Notes: EMF.CLTrial3.Notes,
        }
      case Code.Exam.GroupId.CLFinal:  
        return { 
          ODSphere: EMF.CLFinal.ODSphere,  
          OSSphere: EMF.CLFinal.OSSphere, 
          ODCylinder: EMF.CLFinal.ODCylinder, 
          OSCylinder: EMF.CLFinal.OSCylinder,
          ODAxis: EMF.CLFinal.ODAxis,
          OSAxis: EMF.CLFinal.OSAxis,
          ODAdd: EMF.CLFinal.ODAdd,
          OSAdd: EMF.CLFinal.OSAdd,
          ODSupplier: EMF.CLFinal.ODSupplier,
          OSSupplier: EMF.CLFinal.OSSupplier,
          ODType: EMF.CLFinal.ODType,
          OSType: EMF.CLFinal.OSType,
          ODName: EMF.CLFinal.ODName,
          OSName: EMF.CLFinal.OSName,
          ODColor: EMF.CLFinal.ODColor,
          OSColor: EMF.CLFinal.OSColor,
          ODPack: EMF.CLFinal.ODPack,
          OSPack: EMF.CLFinal.OSPack,
          ODBc: EMF.CLFinal.ODBc,
          OSBc: EMF.CLFinal.OSBc,
          ODDia: EMF.CLFinal.ODDia,
          OSDia: EMF.CLFinal.OSDia,
          Status: EMF.CLFinal.Status,
          ExpiryDate: EMF.CLFinal.ExpiryDate,
          FittingNote: EMF.CLFinal.FittingNote,
          Solution: EMF.CLFinal.Solution,
          Notes: EMF.CLFinal.Notes,
        }
      case Code.Exam.GroupId.Retino:  
        return { 
          ODSphere: EMF.Retino.ODSphere,  
          OSSphere: EMF.Retino.OSSphere, 
          ODCylinder: EMF.Retino.ODCylinder, 
          OSCylinder: EMF.Retino.OSCylinder,
          ODAxis: EMF.Retino.ODAxis,
          OSAxis: EMF.Retino.OSAxis,
          Method: EMF.Retino.Method,
          Notes: EMF.Retino.Notes,
        }    
      case Code.Exam.GroupId.Autorefraction:  
        return { 
          ODSphere: EMF.Autorefraction.ODSphere,  
          OSSphere: EMF.Autorefraction.OSSphere, 
          ODCylinder: EMF.Autorefraction.ODCylinder, 
          OSCylinder: EMF.Autorefraction.OSCylinder,
          ODAxis: EMF.Autorefraction.ODAxis,
          OSAxis: EMF.Autorefraction.OSAxis,
          Method: EMF.Autorefraction.Method,
          Notes: EMF.Autorefraction.Notes,
        } 
      case Code.Exam.GroupId.FinalAdd:  
        return { 
          ODAdd: EMF.FinalAdd.ODFinalAdd,
          OSAdd: EMF.FinalAdd.OSFinalAdd,
          ODAcuity: EMF.FinalAdd.ODAcuity,
          OSAcuity: EMF.FinalAdd.OSAcuity,
          OUAcuity: EMF.FinalAdd.OUAcuity,
          Notes: EMF.FinalAdd.Notes,
        } 
      case Code.Exam.GroupId.Subjective:  
        return { 
          ODSphere: EMF.Subjective.ODSphere,  
          OSSphere: EMF.Subjective.OSSphere, 
          ODCylinder: EMF.Subjective.ODCylinder, 
          OSCylinder: EMF.Subjective.OSCylinder,
          ODAxis: EMF.Subjective.ODAxis,
          OSAxis: EMF.Subjective.OSAxis,
          ODAcuity: EMF.Subjective.ODAcuity,
          OSAcuity: EMF.Subjective.OSAcuity,
          OUAcuity: EMF.Subjective.OUAcuity,

          ODPrism: EMF.Subjective.ODPrism,
          ODOrient: EMF.Subjective.ODOrient,
          OSPrism: EMF.Subjective.OSPrism,
          OSOrient: EMF.Subjective.OSOrient,
          ODPrism2: EMF.Subjective.ODPrism2,
          ODOrient2: EMF.Subjective.ODOrient2,
          OSPrism2: EMF.Subjective.OSPrism2,
          OSOrient2: EMF.Subjective.OSOrient2,

          Method: EMF.Subjective.Method,
          Notes: EMF.Subjective.Notes,
        }  
      case Code.Exam.GroupId.Balance:  
        return { 
          ODSphere: EMF.Balance.ODSphere,  
          OSSphere: EMF.Balance.OSSphere, 
          ODCylinder: EMF.Balance.ODCylinder, 
          OSCylinder: EMF.Balance.OSCylinder,
          ODAxis: EMF.Balance.ODAxis,
          OSAxis: EMF.Balance.OSAxis,
          ODAcuity: EMF.Balance.ODAcuity,
          OSAcuity: EMF.Balance.OSAcuity,
          OUAcuity: EMF.Balance.OUAcuity,

          ODPrism: EMF.Balance.ODPrism,
          ODOrient: EMF.Balance.ODOrient,
          OSPrism: EMF.Balance.OSPrism,
          OSOrient: EMF.Balance.OSOrient,
          ODPrism2: EMF.Balance.ODPrism2,
          ODOrient2: EMF.Balance.ODOrient2,
          OSPrism2: EMF.Balance.OSPrism2,
          OSOrient2: EMF.Balance.OSOrient2,

          Method: EMF.Balance.Method,
          Notes: EMF.Balance.Notes,
        }  
      case Code.Exam.GroupId.Over:  
        return { 
          ODSphere: EMF.Over.ODSphere,  
          OSSphere: EMF.Over.OSSphere, 
          ODCylinder: EMF.Over.ODCylinder, 
          OSCylinder: EMF.Over.OSCylinder,
          ODAxis: EMF.Over.ODAxis,
          OSAxis: EMF.Over.OSAxis,
          ODAcuity: EMF.Over.ODAcuity,
          OSAcuity: EMF.Over.OSAcuity,
          Notes: EMF.Over.Notes,
        } 
      case Code.Exam.GroupId.Unaided:  
        return { 
          DxOD: EMF.Unaided.DxOD,
          DxOS: EMF.Unaided.DxOS,
          DxOU: EMF.Unaided.DxOU,
          NxOD: EMF.Unaided.NxOD,
          NxOS: EMF.Unaided.NxOS,
          NxOU: EMF.Unaided.NxOU,
          IxOD: EMF.Unaided.IxOD,
          IxOS: EMF.Unaided.IxOS,
          IxOU: EMF.Unaided.IxOU,
          Method: EMF.Unaided.Method,
          Notes: EMF.Unaided.Notes,
        } 
      case Code.Exam.GroupId.Aided:  
        return { 
          DxOD: EMF.Aided.DxOD,
          DxOS: EMF.Aided.DxOS,
          DxOU: EMF.Aided.DxOU,
          NxOD: EMF.Aided.NxOD,
          NxOS: EMF.Aided.NxOS,
          NxOU: EMF.Aided.NxOU,
          IxOD: EMF.Aided.IxOD,
          IxOS: EMF.Aided.IxOS,
          IxOU: EMF.Aided.IxOU,
          Method: EMF.Aided.Method,
          Notes: EMF.Aided.Notes,
        } 
      case Code.Exam.GroupId.Pd:  
        return { 
          DxOD: EMF.Pd.DxOD,
          DxOS: EMF.Pd.DxOS,
          DxOU: EMF.Pd.DxOU,
          NxOD: EMF.Pd.NxOD,
          NxOS: EMF.Pd.NxOS,
          NxOU: EMF.Pd.NxOU,
          Notes: EMF.Pd.Notes,
        } 
      case Code.Exam.GroupId.Other:  
        return { 
          DxOD: EMF.Other.DxOD,
          DxOS: EMF.Other.DxOS,
          DxOU: EMF.Other.DxOU,
          NxOD: EMF.Other.NxOD,
          NxOS: EMF.Other.NxOS,
          NxOU: EMF.Other.NxOU,
          Notes: EMF.Other.Notes,
        } 
      default: return {};
    }
  }
  return {};
}

const ProductSummary = (
    frameInfo: Inventory,
    specificationId: number
  ): string => {

    if (!frameInfo || specificationId <= 2) return '';
    if (!frameInfo.inventory_data) return '';
    let serialNo = frameInfo.inventory_serialno;
      
    try {
      const parsedData: CommonDataColumn = JSON.parse(frameInfo.inventory_data);
      let summary = '';
      
      if (specificationId == Number(Code.Option.Control.FRAME)) {
        if (serialNo && serialNo.length > 0) summary += `Sr.No.: ${serialNo} | `;
        if (parsedData.D41 && parsedData.D41.length > 0) summary += `Line: ${parsedData.D41} | `;
        if (parsedData.D61 && parsedData.D61.length > 0) summary += `Model: ${parsedData.D61} | `;
        if (parsedData.D43 && parsedData.D43.length > 0) summary += `Size: ${parsedData.D43} | `;
        if (parsedData.D54 && parsedData.D54.length > 0) summary += `Colour: ${parsedData.D54} | `;
      } 
      else if (specificationId == Number(Code.Option.Control.HEARING)) {
        if (serialNo && serialNo.length > 0) summary += `Sr.No.: ${serialNo} | `;
        if (parsedData.D77 && parsedData.D77.length > 0) summary += `Brand: ${parsedData.D77} | `;
        if (parsedData.D78 && parsedData.D78.length > 0) summary += `Model: ${parsedData.D78} | `;
        if (parsedData.D79 && parsedData.D79.length > 0) summary += `Colour: ${parsedData.D79} | `;
        if (parsedData.D81 && parsedData.D81.length > 0) summary += `Size: ${parsedData.D81} | `;
      }
      else if (specificationId == Number(Code.Option.Control.STOCKING)) {
        if (serialNo && serialNo.length > 0) summary += `Sr.No.: ${serialNo} | `;
        if (parsedData.D69 && parsedData.D69.length > 0) summary += `Brand: ${parsedData.D69} | `;
        if (parsedData.D70 && parsedData.D70.length > 0) summary += `Type: ${parsedData.D70} | `;
        if (parsedData.D71 && parsedData.D71.length > 0) summary += `Size: ${parsedData.D71} | `;
        if (parsedData.D72 && parsedData.D72.length > 0) summary += `Compression: ${parsedData.D72} | `;
        if (parsedData.D73 && parsedData.D73.length > 0) summary += `Colour: ${parsedData.D73} | `;
      }
      
      return summary.endsWith(' | ') ? summary.slice(0, -3) : summary;
    } catch (error) {
      console.error('Failed to parse frame info:', error);
      return '';
    }
  };

const GetMonthDays = (year: number, month: number): OptionType[] => {
    const daysInMonth = new Date(year, month, 0).getDate();
    return Array.from({ length: daysInMonth }, (_, i) => {
      const day = i + 1;
      const label = new Date(year, month - 1, day).toISOString().split('T')[0];
      return { value: day, label };
    });
  };

const GetInventoryDataValues = (
  dataString: string | undefined,
  type: number | undefined,
  column: number
): string => {

  if (!dataString) return '';

  let data: CommonDataColumn;
  try {
    data = JSON.parse(dataString);
  } catch {
    return '';
  }

  if (!type) return '';

  if (type === Number(Code.Option.Control.FRAME)) {
    switch (column) {
      case 10: return data.D41 ?? '';
      case 11: return data.D61 ?? '';
      case 12: return data.D54 ?? '';
      case 13: return data.D43 ?? '';
      default: return '';
    }
  }
  else if (type === Number(Code.Option.Control.STOCKING)) {
    switch (column) {
      case 10: return `${data.D69 ?? ''} ${data.D70 ?? ''}`.trim();
      case 11: return data.D72 ?? '';
      case 12: return data.D73 ?? '';
      case 13: return data.D71 ?? '';
      default: return '';
    }
  }
  else if (type === Number(Code.Option.Control.HEARING)) {
    switch (column) {
      case 10: return data.D77 ?? '';
      case 11: return data.D78 ?? '';
      case 12: return data.D79 ?? '';
      case 13: return data.D81 ?? '';
      default: return '';
    }
  }
  else if (type === Number(Code.Option.Control.LENS)) {
    switch (column) {
      case 10: return data.D59 ?? '';
      case 11: return data.D57 ?? '';
      case 12: return data.D56 ?? '';
      case 13: return data.D55 ?? '';
      default: return '';
    }
  }
  else if (type === Number(Code.Option.Control.CONTACTLENS)) {
    switch (column) {
      case 10: return data.R187 ?? '';
      case 11: return data.R188 ?? '';
      case 12: return data.R189 ?? '';
      case 13: return data.R190 ?? '';
      default: return '';
    }
  }

  return '';
};

function getRandomString(length: number = 12): string {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  return Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join("");
}

const getCurrentDate = (): Date => {
  return new Date(); //return in this format: "Tue Mar 18 2025 15:10:11 GMT-0600 (Mountain Daylight Time)""
};

const getCurrentDateTime = (): Date => {
  let rawDate = Utility.Date.Current();
  let dateObj = new Date(rawDate);

  const now = new Date();
  dateObj.setHours(now.getHours()-6, now.getMinutes(), now.getSeconds(), now.getMilliseconds());
  return dateObj;
};

const getLocalDateTime = (): Date => {
  const now = new Date();
  const timezoneOffsetInHours = now.getTimezoneOffset() / 60;
  
  now.setHours(now.getHours() - timezoneOffsetInHours);
  return now;
};

const getLocalDateTime10am = (): Date => {
  const locateDateTime = getLocalDateTime();
  const onlyDate = getLocalDateTime().toISOString().split('T')[0];
  return new Date(`${onlyDate}T10:00:00`);
};

const setLocalDateTime = (now: Date): Date => {
  const timezoneOffsetInHours = now.getTimezoneOffset() / 60;
  
  now.setHours(now.getHours() - timezoneOffsetInHours);
  return now;
};

const getCurrentTime = (): string => {
  return Utility.Format.Date(new Date(),"HH:mm:ss"); // 'HH:mm:ss'
};

const DateOrNull = (date?: Date | string): Date => {
  const minDate = new Date('1900-01-01T10:00:00');
  
  // Handle null/undefined
  if (!date) {
      return minDate;
  }
  
  // Convert to Date if it's a string
  const dateObj = date instanceof Date ? date : new Date(date);
  
  // Check if invalid or before 1900-01-01
  if (isNaN(dateObj.getTime()) || dateObj < minDate) {
      return minDate;
  }
  
  return dateObj;
};

const getWindowWithOpenForm = (): Window | null => {
  const candidates = [
    window.parent,
    window.parent?.parent,
    window.parent?.parent?.parent,
  ];

  return candidates.find(
    (win) => win && typeof (win as any).openForm === "function"
  ) ?? null;
};

const openClientOnPanel = (title: string, clientId: string) => {
  if(clientId == "4787") return;

  //console.log("Attempting to open form for clientId:", clientId);

  const targetWindow = getWindowWithOpenForm();

  if (!targetWindow) {
    console.warn("openForm not found in any parent window");
    return;
  }

  (targetWindow as any).openForm?.(title, `client/${clientId}`)?.();
};

export const Utility = {
    Storage:{
      Set: setStorage,
      Get: getStorage,
      SetSecure: setStorageSecure,
      GetSecure: getStorageSecure,
      Delete: deleteStorage,
      GetTab: getCurrentTab,
      SetTab: setCurrentTab,
      CompanyName: getCompanyName,
      LocationName: getLocationName,
      LocationColor: getLocationColor,
      UserName: getUserName,
      CompanyId: getCompanyId,
      LocationId: getLocationId,
      DatabaseId: getDatabaseId,
      UserId: getUserId,
      DoctorId: getDoctorId,
      EmployeeId: getEmployeeId,
      PrivilegeList: getPrivilegeList,
      SpecialList: getSpecialList,
      ReportList: getReportList,
      DoctorList: getDoctorList,
      LocationList: getLocationList,
      FileList: getFileList,
    },
    Cookie:{
      Set: setCookie,
      Get: getCookie,
      Delete: deleteCookie,
    },
    isValid:{
      Date: isValidDate,
      Email: isValidEmail,
      PhoneFormat: isValidPhoneFormat,
      Phone: isValidPhone,
      AccessToken: isValidAccessToken,
      RefreshToken: isValidRefreshToken,
      Local: IsValidOrExistsLocal,
      File: IsValidOrExistsFile,
      ChildAge: isAge19OrLess,
      Id: ValidateId,
      Id2: ValidateId2,
      Id3: ValidateId3,
      Id4: ValidateId4,
      Id5: ValidateId5,
    },
    Check:{
      KeyPressed: CheckKeyPressed,
    },
    Calculate:{
      Item : calculateItem,  
      SaleItem : calculateSaleItem,  
      Reverse : reverseCalculate,  
      Price : calculatePrice,  
      Discount : calculateDiscount, 
      roundOffBy10: roundOffBy10, 
      roundOffBy5: roundOffBy5, 
    },
    Format:{
      Date: formatDate,
      DateNow: getDateNow,
      UTCDate: toUTCDate,
      LocalDate: toLocalDate,
      DateOnly: formatViewDate,
      TimeOnly: formatViewTime,
      SafeDate: formatSafeDate,
      Time: formatStringTime,
      DateTime: formatViewDateTime,
      Amount: formatAmount,
      Phone: toPhoneFormat,
      PhoneTyping: ToPhoneFormatTyping,
      ProductInfo: getProductInfo,
      ProductQuick: getProductQuick,
      SerialNumber: formatSerialNumber,
      Age: calculateAge,
      AgeYear: calculateAgeYear,
      AgeYear2: calculateAgeYear2,
      Gender: getGender,
      NewOld: getNewOld,
    },
    Date:{
      Current: getCurrentDate,
      getLocalDate: getLocalDateTime,
      getLocalDate10am: getLocalDateTime10am,
      setlocalDate: setLocalDateTime,
      DateOrNull: DateOrNull,
      CurrentTime: getCurrentTime,
    },
    Value:{
      Text: putStringValue,
      Option: putOptionValue,
      Number: putNumbericValue,
      Date: putDateValue,
      Active: putActiveValue,
      Row: putRowValue,
      Async: getAsyncValue,
    },
    Maths:{
      toDecimal: amountToTwoDecimal,
      toDecimal2: twoDecimal,
      toRound: roundOffDecimal,
    },
    Remove:{
      NA: RemoveNA,
    },
    Convert:{
      TitleCase: toTitleCase,
      Number: toNumber,
      List: stringToList,
      Time: correctTime,
      DateOrToday: correctDateOrToday,
      TimeOrNow: correctTimeOrNow,
      SetString: toSetString,
      DataToOption: mapDataToOptions,
      FormWidth: formWidth,
      formColumnStyle: formColumnStyle,
      formListStyle: formListStyle,
      pageColumnStyle: pageColumnStyle,
      fullColumnStyle: fullColumnStyle,
      ArrayToCSV: ArrayToCSV,
      reverse: reverseString,
      unreverse: unreverseString,
      binary: stringToBinary,
      unbinary: binaryToString,
      HashString: convertHashString,
      AnyToOptions: mapAnyToOptions,
      decodeHTML: decodeHTMLEntities,
      Explanatory: ExplanatoryToId,
    },
    Button:{
      PopupClose: onPopupFormClose,
    },
    Handle:{
      Error: handleError,
      Calculate: handleCalculation,
      ClientChange: handleClientChange,
      ProductChange: handleProductChange,
      openClientOnPanel: openClientOnPanel,
    },
    Sanitize:{
      FormData: sanitizeAll,
      Value: sanitizeValue,
      Script: sanitizeScripts,
      StandardCharsOnly: StandardKeyboardCharsOnly,
    },
    Message:{
      Info: MessageInfo,
      Warning: MessageWarning,
      Error: MessageError,
      Missing: MessageMissing,
      Confirmation: MessageConfirmation,
    },
    Animate:{
      Save: {
        Start: SaveStart,
        End: SaveEnd,
      },
      DeleteRecord: {
        Start: DeleteStart,
        End: DeleteEnd,
      },
      AttachFile: {
        Start: AttachFileStart,
        End: AttachFileEnd,
      },
      DeleteFile: {
        Start: DeleteFileStart,
        End: DeleteFileEnd,
      }
    },
    Join:{
      Url: joinUrl,
      Val: JoinString,
      Edit: joinEditUrl,
      Print: joinPrintUrl,
      Print2: joinPrint2Url,
      Fields: JoinFields,
    },
    Get:{
      OptionValues: getOptionValues,
      FullName: getFullName,
      ClientName: getClientName,
      ClientNameHtml: getClientNameHtml,
      alignClass: getAlignClass,
      CurrentDateTime: getCurrentDateTime,
      Icon: getIcon,
      FieldValue: getFieldValue,
      CorrectEndDate: getCorrectEndDate,
      TotalHours: getTotalHours,
      Reload: getReload,
      DateRange: getDateRangeBySession,
      ModelFields: extractModelFields,
      InvDataValue: GetInventoryDataValues,
      FormName: GetFormName,
      FormLink: GetFormLink,
      Random: getRandomString,
      DocumentType: getDocumentType,
      FormFullName: getFormFullName,
      GroupMapFields: GetGroupMapFields,
      ProductSummary: ProductSummary,
      MonthDays: GetMonthDays,
    },
    Set:{
      PageTitle: setPageTitle,
      Reload: setReload,
      Delay: Delay,
      NewlyCreatedId: setNewlyCreatedId,
      toggleStatus: toggleActiveStatus,
    },
    Image:{
      User: getUserImage,
      Blob: getBlobImage,
    },
    Clean:{
      Object: cleanObject,
      JsonObject: cleanJsonObject,
      Json: cleanJson,
      SQL: CleanSQL,
    },
    Class:{
      Orientation: getOrientationClass,
    }
  };

